// import React, { useState, useEffect } from "react";
// import {
//   Select,
//   DatePicker,
//   Card,
//   Row,
//   Col,
//   Progress,
//   Table,
//   Carousel,
// } from "antd";
// import { FilterOutlined } from "@ant-design/icons";
// import * as echarts from "echarts";
// import Head from "../layout/head/Head";
// import Content from "../layout/content/Content";
// import {
//   BlockBetween,
//   BlockDes,
//   BlockHead,
//   BlockHeadContent,
//   BlockTitle,
// } from "../components/Component";

// const { Option } = Select;
// const { RangePicker } = DatePicker;

// const ProcurexDashboard = () => {
//   const [filters, setFilters] = useState({
//     site: "all",
//     contractor: "all",
//     dateRange: "quarter",
//   });

//   // Mock data based on the handwritten sketches
//   const workOrderSummaryData = {
//     flowData: [
//       {
//         stage: "Allocated Budget",
//         value: 50000000,
//         color: "rgba(76, 175, 80, 0.5)",
//       }, // Transparent Green
//       {
//         stage: "Work Orders",
//         value: 42500000,
//         color: "rgba(33, 150, 243, 0.5)",
//       }, // Transparent Blue
//       {
//         stage: "Under Execution",
//         value: 35000000,
//         color: "rgba(255, 152, 0, 0.5)",
//       }, // Transparent Orange
//       {
//         stage: "RA Bills Pending",
//         value: 22500000,
//         color: "rgba(233, 30, 99, 0.5)",
//       }, // Transparent Pink
//     ],
//     paymentFlow: [
//       {
//         stage: "RA Bills Approved",
//         value: 20000000,
//         color: "rgba(156, 39, 176, 0.5)",
//       }, // Transparent Purple
//       {
//         stage: "Outstanding Payment",
//         value: 12500000,
//         color: "rgba(244, 67, 54, 0.5)",
//       }, // Transparent Red
//       {
//         stage: "Overdue Payment",
//         value: 7500000,
//         color: "rgba(255, 87, 34, 0.5)",
//       }, // Transparent Deep Orange
//       {
//         stage: "Payment Completed",
//         value: 42500000,
//         color: "rgba(63, 81, 181, 0.5)",
//       }, // Transparent Indigo
//     ],
//   };

//   const workOrderStatusData = [
//     { name: "Draft", value: 8, color: "#ff6b6b" },
//     { name: "Amended", value: 12, color: "#4ecdc4" },
//     { name: "Active", value: 25, color: "#45b7d1" },
//     { name: "Pending Approval", value: 18, color: "#96ceb4" },
//     { name: "Released", value: 22, color: "#c4e8c4" },
//     { name: "Finalized", value: 15, color: "#feca57" },
//   ];

//   const topWorkCategoriesData = [
//     { category: "Civil", value: 35, percentage: 35, amount: 17500000 },
//     { category: "Electrical", value: 28, percentage: 28, amount: 14000000 },
//     { category: "Plumbing", value: 20, percentage: 20, amount: 10000000 },
//     { category: "Excavation", value: 12, percentage: 12, amount: 6000000 },
//     { category: "RMC", value: 5, percentage: 5, amount: 2500000 },
//   ];

//   const topContractorsData = [
//     {
//       contractor: "Prime Builders Ltd",
//       orderCount: 45,
//       valuePercentage: 32,
//       valueAmount: 16000000,
//     },
//     {
//       contractor: "BuildTech Solutions",
//       orderCount: 38,
//       valuePercentage: 28,
//       valueAmount: 14000000,
//     },
//     {
//       contractor: "Metro Infrastructure",
//       orderCount: 32,
//       valuePercentage: 24,
//       valueAmount: 12000000,
//     },
//     {
//       contractor: "Apex Construction",
//       orderCount: 28,
//       valuePercentage: 16,
//       valueAmount: 8000000,
//     },
//   ];

//   const budgetVarianceData = [
//     {
//       contractor: "BuildTech Solutions",
//       amendments: 15,
//       count: 12,
//       valuePercentage: 25,
//       valueAmount: 12500000,
//     },
//     {
//       contractor: "Apex Construction",
//       amendments: 8,
//       count: 9,
//       valuePercentage: 18,
//       valueAmount: 9000000,
//     },
//     {
//       contractor: "Metro Infrastructure",
//       amendments: 12,
//       count: 15,
//       valuePercentage: 22,
//       valueAmount: 11000000,
//     },
//     {
//       contractor: "Prime Builders Ltd",
//       amendments: 6,
//       count: 7,
//       valuePercentage: 12,
//       valueAmount: 6000000,
//     },
//   ];

//   const workExecutionData = {
//     planning: { finalized: 65, pending: 35 },
//     execution: { approved: 72, pending: 28 },
//     task: { completed: 58, pending: 42 },
//   };

//   // Helper function to format currency amounts
//   const formatCurrency = (amount) => {
//     if (amount >= 10000000) {
//       return `₹${(amount / 10000000).toFixed(1)}Cr`;
//     } else if (amount >= 100000) {
//       return `₹${(amount / 100000).toFixed(1)}L`;
//     } else if (amount >= 1000) {
//       return `₹${(amount / 1000).toFixed(1)}K`;
//     }
//     return `₹${amount}`;
//   };

//   // Work Order Summary Flow Chain
//   const WorkOrderSummaryFlow = () => {
//     // Map stage names to short abbreviations
//     const getStageAbbreviation = (stageName) => {
//       const abbreviationMap = {
//         "Allocated Budget": "AB",
//         "Work Orders": "WO",
//         "Under Execution": "UE",
//         "RA Bills Pending": "RP",
//         "RA Bills Approved": "RA",
//         "Outstanding Payment": "OP",
//         "Overdue Payment": "OD",
//         "Payment Completed": "PC",
//       };
//       return abbreviationMap[stageName] || "ST";
//     };

//     // Combine all stages in the correct flow order
//     const allStages = [
//       ...workOrderSummaryData.flowData,
//       ...workOrderSummaryData.paymentFlow,
//     ];

//     return (
//       <div>
//         {/* Flow Title */}
//         {/* <div style={{ textAlign: "center", marginBottom: "30px" }}>
//           <h5 style={{
//             color: "#2c3e50",
//             margin: 0,
//             fontSize: "16px",
//             fontWeight: "600"
//           }}>
//             Work Order Process Flow
//           </h5>
//           <p style={{
//             color: "#7f8c8d",
//             fontSize: "12px",
//             margin: "5px 0 0 0"
//           }}>
//             From Budget Allocation to Payment Completion
//           </p>
//         </div> */}

//         {/* Horizontal Flow Container */}
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             position: "relative",
//             flexWrap: "wrap",
//             gap: "10px",
//           }}
//         >
//           {allStages.map((stage, index) => (
//             <React.Fragment key={index}>
//               {/* Stage Node */}
//               <div
//                 style={{
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                   position: "relative",
//                   flex: "1",
//                   minWidth: "120px",
//                 }}
//               >
//                 {/* Stage Circle */}
//                 <div
//                   style={{
//                     width: "60px",
//                     height: "60px",
//                     borderRadius: "50%",
//                     backgroundColor: stage.color || "#3498db",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     // boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
//                     // border: "2px solid rgba(255, 255, 255, 0.8)",
//                     position: "relative",
//                     zIndex: 2,
//                     transition: "all 0.3s ease",
//                   }}
//                 >
//                   <div
//                     style={{
//                       fontSize: "12px",
//                       fontWeight: "bold",
//                       textAlign: "center",
//                       lineHeight: "1.1",
//                       color: "#2c3e50",
//                       textShadow: "none",
//                     }}
//                   >
//                     {getStageAbbreviation(stage.stage)}
//                   </div>
//                 </div>

//                 {/* Stage Label */}
//                 <div
//                   style={{
//                     marginTop: "10px",
//                     textAlign: "center",
//                     maxWidth: "100px",
//                     fontSize: "20px",
//                   }}
//                 >
//                   <div
//                     style={{
//                       fontSize: "12px",
//                       fontWeight: "600",
//                       color: "#2c3e50",
//                       lineHeight: "1.2",
//                       marginBottom: "4px",
//                       whiteSpace: "nowrap",
//                     }}
//                   >
//                     {stage.stage}
//                   </div>

//                   {/* Value Badge */}
//                   <div
//                     style={{
//                       // backgroundColor: "#527292ff",
//                       color: "#34495e",
//                       padding: "4px 8px",
//                       borderRadius: "12px",
//                       fontSize: "14px",
//                       fontWeight: "bold",
//                       display: "inline-block",
//                     }}
//                   >
//                     {formatCurrency(stage.value)}
//                   </div>
//                 </div>
//               </div>

//               {/* Connecting Dotted Line */}
//               {index < allStages.length - 1 && (
//                 <div
//                   style={{
//                     flex: "0 0 40px",
//                     height: "2px",
//                     background: `repeating-linear-gradient(
//                     to right,
//                     #bdc3c7,
//                     #bdc3c7 6px,
//                     transparent 6px,
//                     transparent 12px
//                   )`,
//                     position: "relative",
//                     top: "-25px",
//                     zIndex: 1,
//                   }}
//                 >
//                   {/* Arrow at the end of line */}
//                   <div
//                     style={{
//                       position: "absolute",
//                       right: "-3px",
//                       top: "-4px",
//                       width: 0,
//                       height: 0,
//                       borderLeft: "6px solid #bdc3c7",
//                       borderTop: "5px solid transparent",
//                       borderBottom: "5px solid transparent",
//                     }}
//                   />
//                 </div>
//               )}
//             </React.Fragment>
//           ))}
//         </div>

//         {/* Summary Stats */}
//         <div
//           style={{
//             marginTop: "30px",
//             padding: "15px",
//             backgroundColor: "#f8f9fa",
//             borderRadius: "8px",
//             textAlign: "center",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-around",
//               flexWrap: "wrap",
//               gap: "15px",
//             }}
//           >
//             <div>
//               <div
//                 style={{
//                   fontSize: "12px",
//                   color: "#7f8c8d",
//                   marginBottom: "2px",
//                 }}
//               >
//                 Total Budget
//               </div>
//               <div
//                 style={{
//                   fontSize: "14px",
//                   fontWeight: "bold",
//                   color: "#2c3e50",
//                 }}
//               >
//                 {formatCurrency(workOrderSummaryData.flowData[0]?.value || 0)}
//               </div>
//             </div>

//             <div>
//               <div
//                 style={{
//                   fontSize: "12px",
//                   color: "#7f8c8d",
//                   marginBottom: "2px",
//                 }}
//               >
//                 Completed Payments
//               </div>
//               <div
//                 style={{
//                   fontSize: "14px",
//                   fontWeight: "bold",
//                   color: "#27ae60",
//                 }}
//               >
//                 {formatCurrency(
//                   workOrderSummaryData.paymentFlow[3]?.value || 0
//                 )}
//               </div>
//             </div>

//             <div>
//               <div
//                 style={{
//                   fontSize: "12px",
//                   color: "#7f8c8d",
//                   marginBottom: "2px",
//                 }}
//               >
//                 Outstanding
//               </div>
//               <div
//                 style={{
//                   fontSize: "14px",
//                   fontWeight: "bold",
//                   color: "#e74c3c",
//                 }}
//               >
//                 {formatCurrency(
//                   (workOrderSummaryData.paymentFlow[1]?.value || 0) +
//                     (workOrderSummaryData.paymentFlow[2]?.value || 0)
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   // Work Order Status Pie Chart
//   const WorkOrderStatusChart = () => {
//     const chartRef = React.useRef(null);

//     useEffect(() => {
//       if (chartRef.current && workOrderStatusData.length > 0) {
//         const chart = echarts.init(chartRef.current);
//         const option = {
//           tooltip: {
//             trigger: "item",
//             formatter: "{b}: {c}% ({d}%)",
//           },
//           legend: {
//             orient: "vertical",
//             left: "right",
//             textStyle: { fontSize: 10 },
//           },
//           series: [
//             {
//               type: "pie",
//               radius: ["40%", "70%"],
//               center: ["35%", "50%"],
//               data: workOrderStatusData.map((item) => ({
//                 name: item.name,
//                 value: item.value,
//                 itemStyle: { color: item.color },
//               })),
//               label: {
//                 formatter: "{b}\n{c}%",
//               },
//             },
//           ],
//         };
//         chart.setOption(option);
//         return () => chart.dispose();
//       }
//     }, []);

//     // Show "No Data Found" if empty
//     if (!workOrderStatusData || workOrderStatusData.length === 0) {
//       return (
//         <div
//           style={{
//             width: "100%",
//             height: "300px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             flexDirection: "column",
//             color: "#999",
//           }}
//         >
//           <div style={{ fontSize: "48px", marginBottom: "16px" }}>📊</div>
//           <div style={{ fontSize: "14px", color: "#bfbfbf" }}>No Data</div>
//         </div>
//       );
//     }

//     return <div ref={chartRef} style={{ width: "100%", height: "300px" }} />;
//   };

//   // Top Work Categories Chart
//   const TopWorkCategoriesChart = () => {
//     const chartRef = React.useRef(null);

//     useEffect(() => {
//       if (chartRef.current && topWorkCategoriesData.length > 0) {
//         const chart = echarts.init(chartRef.current);
//         const option = {
//           tooltip: {
//             trigger: "axis",
//             formatter: (params) => {
//               const dataIndex = params[0].dataIndex;
//               const item = topWorkCategoriesData[dataIndex];
//               const formattedAmount = formatCurrency(item.amount);
//               return `${params[0].name}: ${formattedAmount} (${item.percentage}%)`;
//             },
//           },
//           grid: {
//             left: "15%",
//             right: "10%",
//             bottom: "10%",
//             top: "10%",
//           },
//           xAxis: {
//             type: "value",
//             axisLabel: {
//               formatter: (value) => {
//                 if (value >= 10000000) {
//                   return `₹${(value / 10000000).toFixed(1)}Cr`;
//                 } else if (value >= 100000) {
//                   return `₹${(value / 100000).toFixed(1)}L`;
//                 } else if (value >= 1000) {
//                   return `₹${(value / 1000).toFixed(1)}K`;
//                 }
//                 return `₹${value}`;
//               },
//             },
//           },
//           yAxis: {
//             type: "category",
//             data: topWorkCategoriesData.map((item) => item.category),
//           },
//           series: [
//             {
//               type: "bar",
//               data: topWorkCategoriesData.map((item) => item.amount),
//               itemStyle: {
//                 color: (params) => {
//                   const colors = [
//                     "#4ecdc4",
//                     "#45b7d1",
//                     "#96ceb4",
//                     "#feca57",
//                     "#eed08eff",
//                   ];
//                   return colors[params.dataIndex];
//                 },
//               },
//               label: {
//                 show: true,
//                 position: "right",
//                 formatter: (params) => {
//                   const item = topWorkCategoriesData[params.dataIndex];
//                   return formatCurrency(item.amount);
//                 },
//                 fontSize: 10,
//                 color: "#2c3e50",
//               },
//             },
//           ],
//         };
//         chart.setOption(option);
//         return () => chart.dispose();
//       }
//     }, []);

//     // Show "No Data Found" if empty
//     if (!topWorkCategoriesData || topWorkCategoriesData.length === 0) {
//       return (
//         <div
//           style={{
//             width: "100%",
//             height: "300px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             flexDirection: "column",
//             color: "#999",
//           }}
//         >
//           <div style={{ fontSize: "48px", marginBottom: "16px" }}>📊</div>
//           <div style={{ fontSize: "14px", color: "#bfbfbf" }}>No Data</div>
//         </div>
//       );
//     }

//     return <div ref={chartRef} style={{ width: "100%", height: "300px" }} />;
//   };

//   const TopContractorsTable = () => {
//     const columns = [
//       // {
//       //   title: 'Rank',
//       //   key: 'rank',
//       //   width: 60,
//       //   align: 'center',
//       //   render: (text, record, index) => (
//       //     <span style={{
//       //       backgroundColor: '#f39c12',
//       //       color: 'white',
//       //       padding: '4px 8px',
//       //       borderRadius: '50%',
//       //       fontSize: '12px',
//       //       fontWeight: 'bold'
//       //     }}>
//       //       {index + 1}
//       //     </span>
//       //   ),
//       // },
//       {
//         title: "Contractor Name",
//         dataIndex: "contractor",
//         key: "contractor",
//         render: (text) => (
//           <>
//             <strong style={{ color: "#2c3e50", fontSize: "14px" }}>
//               {text}
//             </strong>
//             <div
//               style={{
//                 fontSize: "10px",
//                 color: "#7f8c8d",
//                 marginTop: "2px",
//               }}
//             >
//               Active
//             </div>
//           </>
//         ),
//       },
//       {
//         title: "Order Count",
//         dataIndex: "orderCount",
//         key: "orderCount",
//         align: "center",
//         sorter: (a, b) => a.orderCount - b.orderCount,
//         render: (count) => (
//           <span
//           // style={{
//           //   display: "flex",
//           //   alignItems: "center",
//           //   gap: 8,
//           //   backgroundColor: "#3498db",
//           //   color: "white",
//           //   padding: "6px 12px",
//           //   borderRadius: "8px",
//           //   fontWeight: "bold",
//           //   fontSize: "14px",
//           // }}
//           >
//             {count}
//           </span>
//         ),
//       },
//       {
//         title: "Value",
//         dataIndex: "valueAmount",
//         key: "valueAmount",
//         align: "center",
//         sorter: (a, b) => a.valueAmount - b.valueAmount,
//         render: (amount, record) => (
//           <div>
//             <div
//               style={{
//                 fontWeight: "bold",
//                 color: "#2c3e50",
//                 fontSize: "13px",
//                 marginBottom: "4px",
//               }}
//             >
//               {formatCurrency(amount)}
//             </div>
//             <div style={{ display: "flex", alignItems: "center" }}>
//               <Progress
//                 percent={record.valuePercentage}
//                 size="small"
//                 strokeColor="#27ae60"
//                 style={{ flex: 1, marginRight: "8px" }}
//                 showInfo={false}
//               />
//               <span
//                 style={{
//                   fontWeight: "bold",
//                   color: "#27ae60",
//                   fontSize: "11px",
//                 }}
//               >
//                 {record.valuePercentage}%
//               </span>
//             </div>
//           </div>
//         ),
//       },
//     ];

//     const dataSource = topContractorsData.slice(0, 5).map((item, index) => ({
//       key: index,
//       contractor: item.contractor,
//       orderCount: item.orderCount,
//       valuePercentage: item.valuePercentage,
//       valueAmount: item.valueAmount,
//     }));

//     return (
//       <Table
//         columns={columns}
//         dataSource={dataSource}
//         pagination={false}
//         size="small"
//         bordered={false}
//       />
//     );
//   };

//   // Budget Variance Table
//   const BudgetVarianceTable = () => {
//     const columns = [
//       {
//         title: "Contractor",
//         dataIndex: "contractor",
//         key: "contractor",
//         render: (text) => (
//           <>
//             <strong style={{ color: "#2c3e50", fontSize: "14px" }}>
//               {text}
//             </strong>
//             <div
//               style={{
//                 fontSize: "10px",
//                 color: "#7f8c8d",
//                 marginTop: "2px",
//               }}
//             >
//               Active
//             </div>
//           </>
//         ),
//       },
//       {
//         title: "Amendments Count",
//         dataIndex: "count",
//         key: "count",
//         align: "center",
//         sorter: (a, b) => a.count - b.count,
//         render: (count) => (
//           <span
//             style={{
//               backgroundColor: "#4ecdc4",
//               color: "white",
//               padding: "6px 12px",
//               borderRadius: "8px",
//               fontWeight: "bold",
//               fontSize: "14px",
//             }}
//           >
//             {count}
//           </span>
//         ),
//       },
//       {
//         title: "Value",
//         dataIndex: "valueAmount",
//         key: "valueAmount",
//         align: "center",
//         sorter: (a, b) => a.valueAmount - b.valueAmount,
//         render: (amount, record) => (
//           <div>
//             <div
//               style={{
//                 fontWeight: "bold",
//                 color: "#2c3e50",
//                 fontSize: "13px",
//                 marginBottom: "4px",
//               }}
//             >
//               {formatCurrency(amount)}
//             </div>
//             <div style={{ display: "flex", alignItems: "center" }}>
//               <Progress
//                 percent={record.valuePercentage}
//                 size="small"
//                 strokeColor="#feca57"
//                 style={{ flex: 1, marginRight: "8px" }}
//                 showInfo={false}
//               />
//               <span
//                 style={{
//                   fontWeight: "bold",
//                   color: "#feca57",
//                   fontSize: "11px",
//                 }}
//               >
//                 {record.valuePercentage}%
//               </span>
//             </div>
//           </div>
//         ),
//       },
//     ];

//     const dataSource = budgetVarianceData.map((item, index) => ({
//       key: index,
//       contractor: item.contractor,
//       amendments: item.amendments,
//       count: item.count,
//       valuePercentage: item.valuePercentage,
//       valueAmount: item.valueAmount,
//     }));

//     return (
//       <Table
//         columns={columns}
//         dataSource={dataSource}
//         pagination={false}
//         size="small"
//         bordered={false}
//         // style={{ height: "100%" }}
//       />
//     );
//   };

//   // Work Execution Progress Bars
//   const WorkExecutionProgress = () => (
//     <div style={{ padding: "20px" }}>
//       <Row gutter={[16, 16]}>
//         <Col span={8}>
//           <h4>Planning/Finalized Week</h4>
//           <Progress
//             percent={workExecutionData.planning.finalized}
//             strokeColor="#4ecdc4"
//             format={() => `${workExecutionData.planning.finalized}%`}
//           />
//           <div style={{ marginTop: "10px", fontSize: "12px", color: "#666" }}>
//             Pending: {workExecutionData.planning.pending}%
//           </div>
//         </Col>
//         <Col span={8}>
//           <h4>Execution Approval</h4>
//           <Progress
//             percent={workExecutionData.execution.approved}
//             strokeColor="#45b7d1"
//             format={() => `${workExecutionData.execution.approved}%`}
//           />
//           <div style={{ marginTop: "10px", fontSize: "12px", color: "#666" }}>
//             Pending: {workExecutionData.execution.pending}%
//           </div>
//         </Col>
//         <Col span={8}>
//           <h4>Task</h4>
//           <Progress
//             percent={workExecutionData.task.completed}
//             strokeColor="#96ceb4"
//             format={() => `${workExecutionData.task.completed}%`}
//           />
//           <div style={{ marginTop: "10px", fontSize: "12px", color: "#666" }}>
//             Pending: {workExecutionData.task.pending}%
//           </div>
//         </Col>
//       </Row>
//     </div>
//   );

//   // Complete code for Work Execution Components

//   // Mock data for all components
//   const workExecutionMonitoringData = [
//     {
//       contractor: "Agile Group",
//       plannedFinalized: 85,
//       executed: 65,
//     },
//     {
//       contractor: "Apex Infra",
//       plannedFinalized: 92,
//       executed: 78,
//     },
//     {
//       contractor: "Global Construction",
//       plannedFinalized: 78,
//       executed: 45,
//     },
//     {
//       contractor: "BuildTech Solutions",
//       plannedFinalized: 88,
//       executed: 72,
//     },
//     {
//       contractor: "Metro Infrastructure",
//       plannedFinalized: 70,
//       executed: 55,
//     },
//   ];

//   const pendingExecutionApprovalsData = [
//     {
//       key: 1,
//       contractor: "Apex Construction",
//       workOrder: "WO-2024-001",
//       task: "Civil Foundation",
//       quantity: 100,
//       executedQty: 75,
//       pendingDays: 5,
//     },
//     {
//       key: 2,
//       contractor: "Prime Builders Ltd",
//       workOrder: "WO-2024-002",
//       task: "Electrical Wiring",
//       quantity: 50,
//       executedQty: 30,
//       pendingDays: 12,
//     },
//     {
//       key: 3,
//       contractor: "Metro Infrastructure",
//       workOrder: "WO-2024-003",
//       task: "Plumbing Installation",
//       quantity: 80,
//       executedQty: 65,
//       pendingDays: 8,
//     },
//     {
//       key: 4,
//       contractor: "BuildTech Solutions",
//       workOrder: "WO-2024-004",
//       task: "RMC Pouring",
//       quantity: 120,
//       executedQty: 95,
//       pendingDays: 3,
//     },
//     {
//       key: 5,
//       contractor: "Global Construction",
//       workOrder: "WO-2024-005",
//       task: "Steel Fabrication",
//       quantity: 200,
//       executedQty: 150,
//       pendingDays: 15,
//     },
//   ];

//   const contractorSummaryData = [
//     {
//       contractor: "Align Groups",
//       woValue: 12500000,
//       percentExecuted: 78,
//       raBillsAmount: 9750000,
//       paymentsAmount: 7250000,
//       outstanding: 2500000,
//       overdue: 1200000,
//       avgAgingDays: 15,
//     },
//     {
//       contractor: "Global Construction",
//       woValue: 8750000,
//       percentExecuted: 65,
//       raBillsAmount: 5687500,
//       paymentsAmount: 3487500,
//       outstanding: 3200000,
//       overdue: 800000,
//       avgAgingDays: 22,
//     },
//     {
//       contractor: "Metro Infrastructure",
//       woValue: 6800000,
//       percentExecuted: 82,
//       raBillsAmount: 5576000,
//       paymentsAmount: 3776000,
//       outstanding: 1800000,
//       overdue: 600000,
//       avgAgingDays: 11,
//     },
//     {
//       contractor: "Prime Builders Ltd",
//       woValue: 15200000,
//       percentExecuted: 85,
//       raBillsAmount: 12920000,
//       paymentsAmount: 9500000,
//       outstanding: 3420000,
//       overdue: 850000,
//       avgAgingDays: 12,
//     },
//     {
//       contractor: "BuildTech Solutions",
//       woValue: 9800000,
//       percentExecuted: 72,
//       raBillsAmount: 7056000,
//       paymentsAmount: 5200000,
//       outstanding: 1856000,
//       overdue: 1100000,
//       avgAgingDays: 18,
//     },
//     {
//       contractor: "Apex Construction",
//       woValue: 7300000,
//       percentExecuted: 58,
//       raBillsAmount: 4234000,
//       paymentsAmount: 2800000,
//       outstanding: 1434000,
//       overdue: 950000,
//       avgAgingDays: 25,
//     },
//     {
//       contractor: "Elite Engineering Co",
//       woValue: 11600000,
//       percentExecuted: 91,
//       raBillsAmount: 10556000,
//       paymentsAmount: 8900000,
//       outstanding: 1656000,
//       overdue: 420000,
//       avgAgingDays: 9,
//     },
//     {
//       contractor: "Phoenix Developers",
//       woValue: 13400000,
//       percentExecuted: 76,
//       raBillsAmount: 10184000,
//       paymentsAmount: 7650000,
//       outstanding: 2534000,
//       overdue: 1350000,
//       avgAgingDays: 19,
//     },
//     {
//       contractor: "Sterling Infrastructure",
//       woValue: 8900000,
//       percentExecuted: 68,
//       raBillsAmount: 6052000,
//       paymentsAmount: 4200000,
//       outstanding: 1852000,
//       overdue: 750000,
//       avgAgingDays: 16,
//     },
//     {
//       contractor: "Titan Constructions",
//       woValue: 16800000,
//       percentExecuted: 89,
//       raBillsAmount: 14952000,
//       paymentsAmount: 12200000,
//       outstanding: 2752000,
//       overdue: 980000,
//       avgAgingDays: 13,
//     },
//     {
//       contractor: "Skyline Projects",
//       woValue: 10500000,
//       percentExecuted: 63,
//       raBillsAmount: 6615000,
//       paymentsAmount: 4800000,
//       outstanding: 1815000,
//       overdue: 1200000,
//       avgAgingDays: 21,
//     },
//     {
//       contractor: "Royal Builders Group",
//       woValue: 14100000,
//       percentExecuted: 87,
//       raBillsAmount: 12267000,
//       paymentsAmount: 10150000,
//       outstanding: 2117000,
//       overdue: 650000,
//       avgAgingDays: 14,
//     },
//   ];

//   // ============================================================================
//   // 1. WORK EXECUTION MONITORING CHART
//   // ============================================================================
//   const WorkExecutionMonitoringChart = () => {
//     const chartRef = React.useRef(null);

//     useEffect(() => {
//       if (chartRef.current && workExecutionMonitoringData.length > 0) {
//         const chart = echarts.init(chartRef.current);
//         const option = {
//           // title: {
//           //   text: "Work Execution Monitoring",
//           //   left: "center",
//           //   textStyle: {
//           //     fontSize: 16,
//           //     fontWeight: "bold",
//           //     color: "#2c3e50",
//           //   },
//           // },
//           tooltip: {
//             trigger: "axis",
//             axisPointer: {
//               type: "shadow",
//             },
//             formatter: function (params) {
//               let result = `<strong>${params[0].axisValue}</strong><br/>`;
//               params.forEach((param) => {
//                 result += `${param.seriesName}: ${param.value}%<br/>`;
//               });
//               return result;
//             },
//           },
//           legend: {
//             data: ["Planned/Finalized Work", "Executed Work"],
//             bottom: 0,
//             textStyle: {
//               fontSize: 12,
//             },
//           },
//           grid: {
//             left: "3%",
//             right: "4%",
//             bottom: "15%",
//             top: "15%",
//             containLabel: true,
//           },
//           xAxis: {
//             type: "category",
//             data: workExecutionMonitoringData.map((item) => item.contractor),
//             axisLabel: {
//               fontSize: 12,
//               fontWeight: "bold",
//             },
//           },
//           yAxis: {
//             type: "value",
//             max: 100,
//             min: 0,
//             axisLabel: {
//               formatter: "{value}%",
//               fontSize: 12,
//             },
//             name: "Work Progress (%)",
//             nameTextStyle: {
//               fontSize: 12,
//               color: "#666",
//             },
//           },
//           series: [
//             {
//               name: "Planned/Finalized Work",
//               type: "bar",
//               data: workExecutionMonitoringData.map(
//                 (item) => item.plannedFinalized
//               ),
//               itemStyle: {
//                 color: "#e8f5e8",
//                 borderColor: "#4ecdc4",
//                 borderWidth: 1,
//               },
//               barWidth: "35%",
//               label: {
//                 show: false,
//                 position: "top",
//                 formatter: "{c}%",
//                 fontSize: 10,
//               },
//             },
//             {
//               name: "Executed Work",
//               type: "bar",
//               data: workExecutionMonitoringData.map((item) => item.executed),
//               itemStyle: {
//                 color: "#4ecdc4",
//                 borderRadius: [2, 2, 0, 0],
//               },
//               barWidth: "35%",
//               label: {
//                 show: true,
//                 position: "top",
//                 formatter: "{c}%",
//                 fontSize: 10,
//                 color: "#2c3e50",
//                 fontWeight: "bold",
//               },
//             },
//           ],
//           emphasis: {
//             itemStyle: {
//               shadowBlur: 10,
//               shadowOffsetX: 0,
//               shadowColor: "rgba(0, 0, 0, 0.5)",
//             },
//           },
//         };

//         chart.setOption(option);

//         // Handle window resize
//         const handleResize = () => {
//           chart.resize();
//         };
//         window.addEventListener("resize", handleResize);

//         return () => {
//           window.removeEventListener("resize", handleResize);
//           chart.dispose();
//         };
//       }
//     }, []);

//     // Show "No Data Found" if empty
//     if (!workExecutionMonitoringData || workExecutionMonitoringData.length === 0) {
//       return (
//         <div
//           style={{
//             width: "100%",
//             height: "320px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             flexDirection: "column",
//             color: "#999",
//           }}
//         >
//           <div style={{ fontSize: "48px", marginBottom: "16px" }}>📊</div>
//           <div style={{ fontSize: "14px", color: "#bfbfbf" }}>No Data</div>
//         </div>
//       );
//     }

//     return (
//       <div>
//         <div ref={chartRef} style={{ width: "100%", height: "320px" }} />
//       </div>
//     );
//   };

//   // ============================================================================
//   // 2. PENDING EXECUTION APPROVALS TABLE
//   // ============================================================================
//   const PendingExecutionApprovalsTable = () => {
//     const columns = [
//       {
//         title: "Contractor",
//         dataIndex: "contractor",
//         key: "contractor",
//         width: 120,
//         render: (text) => (
//           <div>
//             <strong style={{ color: "#2c3e50", fontSize: "13px" }}>
//               {text}
//             </strong>
//             <div
//               style={{
//                 fontSize: "10px",
//                 color: "#7f8c8d",
//                 marginTop: "2px",
//               }}
//             >
//               Active
//             </div>
//           </div>
//         ),
//         // filters: [
//         //   { text: "Contractor 1", value: "Contractor 1" },
//         //   { text: "Contractor 2", value: "Contractor 2" },
//         //   { text: "Contractor 3", value: "Contractor 3" },
//         //   { text: "Contractor 4", value: "Contractor 4" },
//         // ],
//         // onFilter: (value, record) => record.contractor.includes(value),
//       },
//       {
//         title: "WO#",
//         dataIndex: "workOrder",
//         key: "workOrder",
//         width: 100,
//         render: (text) => (
//           <span
//             style={{
//               backgroundColor: "#e3f2fd",
//               padding: "4px 8px",
//               borderRadius: "4px",
//               fontSize: "11px",
//               fontWeight: "bold",
//               color: "#1976d2",
//             }}
//           >
//             {text}
//           </span>
//         ),
//       },
//       {
//         title: "Task",
//         dataIndex: "task",
//         key: "task",
//         width: 120,
//         render: (text) => (
//           <div
//             style={{
//               fontSize: "12px",
//               color: "#2c3e50",
//               lineHeight: "1.3",
//             }}
//           >
//             {text}
//           </div>
//         ),
//       },
//       {
//         title: "QTY",
//         dataIndex: "quantity",
//         key: "quantity",
//         width: 60,
//         align: "center",
//         // sorter: (a, b) => a.quantity - b.quantity,
//         render: (qty) => (
//           <span
//             style={{
//               fontWeight: "bold",
//               color: "#2c3e50",
//             }}
//           >
//             {qty}
//           </span>
//         ),
//       },
//       {
//         title: "Executed QTY",
//         dataIndex: "executedQty",
//         key: "executedQty",
//         width: 120,
//         align: "center",
//         // sorter: (a, b) =>
//         //   a.executedQty / a.quantity - b.executedQty / b.quantity,
//         render: (executedQty, record) => {
//           const percentage = Math.round((executedQty / record.quantity) * 100);
//           return (
//             <div>
//               {/* <div
//                 style={{
//                   fontSize: "12px",
//                   fontWeight: "bold",
//                   marginBottom: "4px",
//                   color:
//                     percentage >= 80
//                       ? "#27ae60"
//                       : percentage >= 60
//                       ? "#f39c12"
//                       : "#e74c3c",
//                 }}
//               >
//                 {executedQty}/{record.quantity}
//               </div> */}
//               {/* <Progress
//                 percent={percentage}
//                 size="small"
//                 strokeColor={
//                   percentage >= 80
//                     ? "#27ae60"
//                     : percentage >= 60
//                     ? "#f39c12"
//                     : "#e74c3c"
//                 }
//                 showInfo={false}
//                 style={{ marginBottom: "2px" }}
//               /> */}
//               <div
//               // style={{
//               //   fontSize: "10px",
//               //   color: "#7f8c8d",
//               // }}
//               >
//                 {percentage}
//               </div>
//             </div>
//           );
//         },
//       },
//       {
//         title: "Pending Days",
//         dataIndex: "pendingDays",
//         key: "pendingDays",
//         width: 150,
//         align: "center",
//         // sorter: (a, b) => a.pendingDays - b.pendingDays,
//         render: (days) => {
//           let color = "#27ae60";
//           let bgColor = "#d5f4e6";
//           let status = "On Track";

//           if (days > 10) {
//             color = "#e74c3c";
//             bgColor = "#ffeaea";
//             status = "Critical";
//           } else if (days > 5) {
//             color = "#f39c12";
//             bgColor = "#fff3cd";
//             status = "Warning";
//           }

//           return (
//             <div>
//               <span
//               // style={{
//               //   backgroundColor: color,
//               //   color: "white",
//               //   padding: "4px 8px",
//               //   borderRadius: "12px",
//               //   fontSize: "11px",
//               //   fontWeight: "bold",
//               //   display: "inline-block",
//               //   marginBottom: "2px",
//               // }}
//               >
//                 {days} days
//               </span>
//               {/* <div
//                 style={{
//                   fontSize: "9px",
//                   color: color,
//                   fontWeight: "bold",
//                 }}
//               >
//                 {status}
//               </div> */}
//             </div>
//           );
//         },
//       },
//     ];

//     return (
//       <div>
//         <Table
//           columns={columns}
//           dataSource={pendingExecutionApprovalsData}
//           pagination={false}
//           // pagination={{
//           //   pageSize: 5,
//           //   showSizeChanger: false,
//           //   showQuickJumper: true,
//           //   showTotal: (total, range) =>
//           //     `${range[0]}-${range[1]} of ${total} items`,
//           // }}
//           size="small"
//           // scroll={{ y: 250 }}
//           bordered={false}
//           // rowClassName={(record) => {
//           //   if (record.pendingDays > 10) return "critical-row";
//           //   if (record.pendingDays > 5) return "warning-row";
//           //   return "normal-row";
//           // }}
//         />

//         <style jsx>{`
//           .critical-row {
//             background-color: #ffeaea !important;
//           }
//           .warning-row {
//             background-color: #fff3cd !important;
//           }
//           .normal-row {
//             background-color: #f8f9fa !important;
//           }
//         `}</style>
//       </div>
//     );
//   };

//   // ============================================================================
//   // 3. CONTRACTOR SUMMARY CARDS
//   // ============================================================================
//   const ContractorSummaryCarousel = () => {
//     const formatCurrency = (amount) => {
//       if (amount >= 10000000) {
//         return `₹${(amount / 10000000).toFixed(1)}Cr`;
//       } else if (amount >= 100000) {
//         return `₹${(amount / 100000).toFixed(1)}L`;
//       } else if (amount >= 1000) {
//         return `₹${(amount / 1000).toFixed(1)}K`;
//       }
//       return `₹${amount}`;
//     };

//     const getStatusColor = (contractor, index) => {
//       const colors = ["#3498db", "#e74c3c", "#27ae60", "#f39c12", "#9b59b6"];
//       return colors[index % colors.length];
//     };

//     const getPerformanceRating = (percentExecuted, avgAgingDays) => {
//       if (percentExecuted >= 80 && avgAgingDays <= 15)
//         return { rating: "Excellent", color: "#27ae60" };
//       if (percentExecuted >= 70 && avgAgingDays <= 20)
//         return { rating: "Good", color: "#f39c12" };
//       if (percentExecuted >= 60) return { rating: "Average", color: "#e67e22" };
//       return { rating: "Poor", color: "#e74c3c" };
//     };

//     // Custom arrow components
//     const CustomPrevArrow = (props) => {
//       const { onClick } = props;
//       return (
//         <div
//           onClick={onClick}
//           style={{
//             position: "absolute",
//             left: "-10px",
//             top: "50%",
//             transform: "translateY(-50%)",
//             zIndex: 10,
//             backgroundColor: "white",
//             borderRadius: "50%",
//             width: "30px",
//             height: "30px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             cursor: "pointer",
//             // boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
//             transition: "all 0.3s ease",
//           }}
//           onMouseEnter={(e) => {
//             e.currentTarget.style.backgroundColor = "white";
//             e.currentTarget.style.transform = "translateY(-50%) scale(1.1)";
//           }}
//           onMouseLeave={(e) => {
//             e.currentTarget.style.backgroundColor = "white";
//             e.currentTarget.style.transform = "translateY(-50%) scale(1)";
//           }}
//         >
//           <span
//             style={{ color: "#1890ff", fontSize: "14px", fontWeight: "bold" }}
//           >
//             ❮
//           </span>
//         </div>
//       );
//     };

//     const CustomNextArrow = (props) => {
//       const { onClick } = props;
//       return (
//         <div
//           onClick={onClick}
//           style={{
//             position: "absolute",
//             right: "-10px",
//             top: "50%",
//             transform: "translateY(-50%)",
//             zIndex: 10,
//             backgroundColor: "white",
//             borderRadius: "50%",
//             width: "30px",
//             height: "30px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             cursor: "pointer",
//             // boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
//             transition: "all 0.3s ease",
//           }}
//           onMouseEnter={(e) => {
//             e.currentTarget.style.backgroundColor = "white";
//             e.currentTarget.style.transform = "translateY(-50%) scale(1.1)";
//           }}
//           onMouseLeave={(e) => {
//             e.currentTarget.style.backgroundColor = "white";
//             e.currentTarget.style.transform = "translateY(-50%) scale(1)";
//           }}
//         >
//           <span
//             style={{ color: "#1890ff", fontSize: "14px", fontWeight: "bold" }}
//           >
//             ❯
//           </span>
//         </div>
//       );
//     };

//     // Show "No Data Found" if empty
//     if (!contractorSummaryData || contractorSummaryData.length === 0) {
//       return (
//         <div
//           style={{
//             width: "100%",
//             height: "320px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             flexDirection: "column",
//             color: "#999",
//           }}
//         >
//           <div style={{ fontSize: "48px", marginBottom: "16px" }}>📊</div>
//           <div style={{ fontSize: "14px", color: "#bfbfbf" }}>No Data</div>
//         </div>
//       );
//     }

//     // Custom carousel settings
//     const carouselSettings = {
//       dots: true,
//       infinite: true,
//       speed: 500,
//       slidesToShow: 3,
//       slidesToScroll: 1,
//       autoplay: true,
//       autoplaySpeed: 4000,
//       arrows: true,
//       prevArrow: <CustomPrevArrow />,
//       nextArrow: <CustomNextArrow />,
//       responsive: [
//         {
//           breakpoint: 1200,
//           settings: {
//             slidesToShow: 2,
//             slidesToScroll: 1,
//             arrows: true,
//             prevArrow: <CustomPrevArrow />,
//             nextArrow: <CustomNextArrow />,
//           },
//         },
//         {
//           breakpoint: 768,
//           settings: {
//             slidesToShow: 1,
//             slidesToScroll: 1,
//             arrows: true,
//             prevArrow: <CustomPrevArrow />,
//             nextArrow: <CustomNextArrow />,
//           },
//         },
//       ],
//     };

//     return (
//       <div style={{ padding: "0", position: "relative" }}>
//         <Carousel {...carouselSettings}>
//           {contractorSummaryData.map((contractor, index) => {
//             const performance = getPerformanceRating(
//               contractor.percentExecuted,
//               contractor.avgAgingDays
//             );
//             const statusColor = getStatusColor(contractor, index);

//             return (
//               <div key={index} style={{ padding: "0", margin: "0" }}>
//                 <Card
//                   title={
//                     <div
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "center",
//                       }}
//                     >
//                       <span style={{ color: "#2c3e50", fontSize: "16px" }}>
//                         {contractor.contractor}
//                       </span>
//                       {/* <span
//                         style={{
//                           backgroundColor: performance.color,
//                           color: "white",
//                           padding: "2px 8px",
//                           borderRadius: "8px",
//                           fontSize: "10px",
//                           fontWeight: "bold",
//                         }}
//                       >
//                         {performance.rating}
//                       </span> */}
//                     </div>
//                   }
//                   size="small"
//                   style={{
//                     borderLeft: `4px solid ${statusColor}`,
//                     height: "320px",
//                     boxShadow: "0 3px 8px rgba(0,0,0,0.12)",
//                     borderRadius: "8px",
//                     // margin: "0 auto",
//                     width: "100%",
//                     maxWidth: "460px",
//                   }}
//                   headStyle={{
//                     backgroundColor: "#f8f9fa",
//                     borderRadius: "8px 8px 0 0",
//                   }}
//                 >
//                   <div style={{ fontSize: "13px", lineHeight: "1.4" }}>
//                     {/* WO Value */}
//                     <div
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         marginBottom: "8px",
//                         padding: "6px",
//                         backgroundColor: "#f8f9fa",
//                         borderRadius: "4px",
//                       }}
//                     >
//                       <span>
//                         <strong>WO Value:</strong>
//                       </span>
//                       <span
//                         style={{
//                           fontWeight: "bold",
//                           color: "#2c3e50",
//                           fontSize: "13px",
//                         }}
//                       >
//                         {formatCurrency(contractor.woValue)}
//                       </span>
//                     </div>

//                     {/* Execution Progress */}
//                     <div style={{ marginBottom: "10px" }}>
//                       <div
//                         style={{
//                           display: "flex",
//                           justifyContent: "space-between",
//                           marginBottom: "4px",
//                         }}
//                       >
//                         <span>
//                           <strong>% Executed:</strong>
//                         </span>
//                         <span
//                           style={{
//                             fontWeight: "bold",
//                             color: statusColor,
//                             fontSize: "13px",
//                           }}
//                         >
//                           {contractor.percentExecuted}%
//                         </span>
//                       </div>
//                       <Progress
//                         percent={contractor.percentExecuted}
//                         size="small"
//                         strokeColor={statusColor}
//                         style={{ marginTop: "4px" }}
//                         showInfo={false}
//                       />
//                       <div
//                         style={{
//                           fontSize: "12px",
//                           color: "#7f8c8d",
//                           textAlign: "right",
//                           marginTop: "4px",
//                         }}
//                       >
//                         {formatCurrency(
//                           (contractor.woValue * contractor.percentExecuted) /
//                             100
//                         )}{" "}
//                         completed
//                       </div>
//                     </div>

//                     {/* RA Bills and Payments */}
//                     <Row gutter={8} style={{ marginBottom: "8px" }}>
//                       <Col span={12}>
//                         <div
//                           style={{
//                             backgroundColor: "#e8f5e8",
//                             padding: "6px",
//                             borderRadius: "4px",
//                             textAlign: "center",
//                           }}
//                         >
//                           <div
//                             style={{
//                               fontSize: "13px",
//                               color: "#666",
//                               marginBottom: "1px",
//                             }}
//                           >
//                             RA Bills
//                           </div>
//                           <div
//                             style={{
//                               fontWeight: "bold",
//                               fontSize: "13px",
//                               color: "#27ae60",
//                             }}
//                           >
//                             {formatCurrency(contractor.raBillsAmount)}
//                           </div>
//                         </div>
//                       </Col>
//                       <Col span={12}>
//                         <div
//                           style={{
//                             backgroundColor: "#e3f2fd",
//                             padding: "6px",
//                             borderRadius: "4px",
//                             textAlign: "center",
//                           }}
//                         >
//                           <div
//                             style={{
//                               fontSize: "13px",
//                               color: "#666",
//                               marginBottom: "1px",
//                             }}
//                           >
//                             Payments
//                           </div>
//                           <div
//                             style={{
//                               fontWeight: "bold",
//                               fontSize: "13px",
//                               color: "#3498db",
//                             }}
//                           >
//                             {formatCurrency(contractor.paymentsAmount)}
//                           </div>
//                         </div>
//                       </Col>
//                     </Row>

//                     {/* Financial Details */}
//                     <div
//                       style={{
//                         borderTop: "1px solid #eee",
//                         paddingTop: "6px",
//                       }}
//                     >
//                       <div
//                         style={{
//                           display: "flex",
//                           justifyContent: "space-between",
//                           marginBottom: "4px",
//                         }}
//                       >
//                         <span>
//                           <strong>Outstanding:</strong>
//                         </span>
//                         <span
//                           style={{
//                             fontWeight: "bold",
//                             color: "#f39c12",
//                             fontSize: "13px",
//                           }}
//                         >
//                           {formatCurrency(contractor.outstanding)}
//                         </span>
//                       </div>

//                       <div
//                         style={{
//                           display: "flex",
//                           justifyContent: "space-between",
//                           marginBottom: "4px",
//                         }}
//                       >
//                         <span>
//                           <strong>Overdue:</strong>
//                         </span>
//                         <span
//                           style={{
//                             fontWeight: "bold",
//                             color: "#e74c3c",
//                             fontSize: "13px",
//                           }}
//                         >
//                           {formatCurrency(contractor.overdue)}
//                         </span>
//                       </div>

//                       <div
//                         style={{
//                           display: "flex",
//                           justifyContent: "space-between",
//                           alignItems: "center",
//                           marginTop: "6px",
//                           paddingTop: "4px",
//                           borderTop: "1px solid #eee",
//                         }}
//                       >
//                         <span>
//                           <strong>Avg Aging:</strong>
//                         </span>
//                         <span
//                           style={{
//                             backgroundColor:
//                               contractor.avgAgingDays > 20
//                                 ? "#e74c3c"
//                                 : contractor.avgAgingDays > 15
//                                 ? "#f39c12"
//                                 : "#27ae60",
//                             color: "white",
//                             padding: "3px 8px",
//                             borderRadius: "10px",
//                             fontSize: "13px",
//                             fontWeight: "bold",
//                           }}
//                         >
//                           {contractor.avgAgingDays} days
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                 </Card>
//               </div>
//             );
//           })}
//         </Carousel>
//       </div>
//     );
//   };

//   return (
//     <React.Fragment>
//       <Head title="projects dashboard" />
//       <Content>
//         <BlockHead size="sm">
//           <BlockBetween>
//             <BlockHeadContent>
//               <BlockTitle page>Work Order Dashboard</BlockTitle>
//               <BlockDes className="text-soft">
//                 <p>Welcome to Procurex.</p>
//               </BlockDes>
//             </BlockHeadContent>
//             <BlockHeadContent>
//               <Row gutter={16} align="middle">
//                 <Col>
//                   <label style={{ marginRight: 8 }}>Site:</label>
//                   <Select
//                     value={filters.site}
//                     style={{ width: 150 }}
//                     onChange={(value) =>
//                       setFilters({ ...filters, site: value })
//                     }
//                   >
//                     <Option value="all">All Sites</Option>
//                     <Option value="site1">Site 1</Option>
//                     <Option value="site2">Site 2</Option>
//                   </Select>
//                 </Col>
//                 <Col>
//                   <label style={{ marginRight: 8 }}>Contractor:</label>
//                   <Select
//                     value={filters.contractor}
//                     style={{ width: 150 }}
//                     onChange={(value) =>
//                       setFilters({ ...filters, contractor: value })
//                     }
//                   >
//                     <Option value="all">All Contractors</Option>
//                     <Option value="con1">Contractor 1</Option>
//                     <Option value="con2">Contractor 2</Option>
//                   </Select>
//                 </Col>
//                 <Col>
//                   <label style={{ marginRight: 8 }}>Period:</label>
//                   <Select
//                     value={filters.dateRange}
//                     style={{ width: 150 }}
//                     onChange={(value) =>
//                       setFilters({ ...filters, dateRange: value })
//                     }
//                   >
//                     <Option value="month">Month</Option>
//                     <Option value="quarter">Quarter</Option>
//                     <Option value="year">Year</Option>
//                   </Select>
//                 </Col>
//               </Row>
//             </BlockHeadContent>
//           </BlockBetween>
//         </BlockHead>
//         {/* Work Order Summary - Full Width */}
//         <Row gutter={16} style={{ marginBottom: "20px" }}>
//           <Col xs={24}>
//             <Card
//               title="Work Order Summary"
//               bordered={false}
//               style={{ minHeight: "300px" }}
//             >
//               <WorkOrderSummaryFlow />
//             </Card>
//           </Col>
//         </Row>

//         <Row gutter={16} style={{ marginBottom: "20px" }}>
//           <Col xs={24} lg={12}>
//             <Card title="Work Order Status" style={{ height: "400px" }}>
//               <WorkOrderStatusChart />
//             </Card>
//           </Col>
//           {/* Top Work Categories */}
//           <Col xs={24} lg={12}>
//             <Card
//               title={
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                   }}
//                 >
//                   <span>Top Work Categories</span>
//                   <a
//                     href="#"
//                     style={{
//                       color: "#cec4c4ff",
//                       cursor: "not-allowed",
//                       fontSize: "12px",
//                       textDecoration: "none",
//                     }}
//                     onClick={(e) => e.preventDefault()}
//                   >
//                     View More
//                   </a>
//                 </div>
//               }
//               style={{ height: "400px" }}
//             >
//               <TopWorkCategoriesChart />
//             </Card>
//           </Col>
//         </Row>

//         <Row gutter={16} style={{ marginBottom: "20px" }}>
//           {/* Top Contractors */}
//           <Col xs={24} lg={12}>
//             <Card
//               title={
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                   }}
//                 >
//                   <span>Top Contractors by Work Orders</span>
//                   <a
//                     href="#"
//                     style={{
//                       color: "#cec4c4ff",
//                       cursor: "not-allowed",
//                       fontSize: "12px",
//                       textDecoration: "none",
//                     }}
//                     onClick={(e) => e.preventDefault()}
//                   >
//                     View More
//                   </a>
//                 </div>
//               }
//               style={{ height: "400px" }}
//             >
//               <TopContractorsTable />
//             </Card>
//           </Col>
//           {/* Budget Variance */}
//           <Col xs={24} lg={12}>
//             <Card
//               title={
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                   }}
//                 >
//                   <span>Budget Variance by Contractor</span>
//                   <a
//                     href="#"
//                     style={{
//                       color: "#cec4c4ff",
//                       cursor: "not-allowed",
//                       fontSize: "12px",
//                       textDecoration: "none",
//                     }}
//                     onClick={(e) => e.preventDefault()}
//                   >
//                     View More
//                   </a>
//                 </div>
//               }
//               style={{ height: "400px" }}
//             >
//               <BudgetVarianceTable />
//             </Card>
//           </Col>

//           {/* Work Execution Status */}
//           {/* <Col xs={24} lg={12}>
//           <Card title="Work Execution Status" style={{ height: "400px" }}>
//             <WorkExecutionProgress />
//           </Card>
//         </Col> */}
//         </Row>
//         <Row gutter={16} style={{ marginBottom: "20px" }}>
//           {/* Work Execution Status */}
//           <Col xs={24} lg={12}>
//             <Card
//               title={
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                   }}
//                 >
//                   <span>Work Execution Monitoring</span>
//                   <a
//                     href="#"
//                     style={{
//                       color: "#cec4c4ff",
//                       cursor: "not-allowed",
//                       fontSize: "12px",
//                       textDecoration: "none",
//                     }}
//                     onClick={(e) => e.preventDefault()}
//                   >
//                     View More
//                   </a>
//                 </div>
//               }
//               style={{ height: "450px" }}
//             >
//               <WorkExecutionMonitoringChart />
//             </Card>
//           </Col>
//           {/* Pending Execution Approvals */}
//           <Col xs={24} lg={12}>
//             <Card
//               title={
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                   }}
//                 >
//                   <span>Pending Execution Approvals</span>
//                   <a
//                     href="#"
//                     style={{
//                       color: "#cec4c4ff",
//                       cursor: "not-allowed",
//                       fontSize: "12px",
//                       textDecoration: "none",
//                     }}
//                     onClick={(e) => e.preventDefault()}
//                   >
//                     View More
//                   </a>
//                 </div>
//               }
//             >
//               <PendingExecutionApprovalsTable />
//             </Card>
//           </Col>
//         </Row>
//         {/* Contractor Summary - Full Width Carousel */}
//         <Row gutter={16} style={{ marginBottom: "20px" }}>
//           <Col xs={24}>
//             <Card
//               title={
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                   }}
//                 >
//                   <span>Contractor Summary</span>
//                   <a
//                     href="#"
//                     style={{
//                       color: "#cec4c4ff",
//                       cursor: "not-allowed",
//                       fontSize: "12px",
//                       textDecoration: "none",
//                     }}
//                     onClick={(e) => e.preventDefault()}
//                   >
//                     View More
//                   </a>
//                 </div>
//               }
//               style={{ minHeight: "380px" }}
//             >
//               <ContractorSummaryCarousel />
//             </Card>
//           </Col>
//         </Row>
//       </Content>
//     </React.Fragment>
//   );
// };

// export default ProcurexDashboard;

import React, { useState, useEffect } from "react";
import {
  Select,
  DatePicker,
  Card,
  Row,
  Col,
  Progress,
  Table,
  Carousel,
  Spin,
  Alert,
  Button,
  Empty,
  Tooltip,
  Radio,
} from "antd";
import { FilterOutlined, ReloadOutlined } from "@ant-design/icons";
import * as echarts from "echarts";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Head from "../layout/head/Head";
import Content from "../layout/content/Content";
import {
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
} from "../components/Component";
import DashboardApis from "../api/WorkOrderManagement/DashboardApis";
import dropdownApis from "../api/WorkOrderManagement/DropdownApis";

const { Option } = Select;
const { RangePicker } = DatePicker;
const { Button: RadioButton, Group: RadioGroup } = Radio;

const ProcurexDashboard = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { data: currentUser } = useSelector((state) => state.currentUser);

  // Get flowType from URL or default to "client"
  const flowType = searchParams.get("flowType") || "client";
  const isClientFlow = flowType?.toLowerCase() === "client";

  // Capitalize flowType for API (Client/Contractor) - same pattern as other pages
  const flowTypeParam = isClientFlow ? "Client" : "Contractor";

  const [filters, setFilters] = useState({
    site: "all",
    contractor: "all",
    dateRange: "quarter",
  });

  // Dropdown options
  const [siteOptions, setSiteOptions] = useState([]);
  const [contractorOptions, setContractorOptions] = useState([]);

  // Load site options from currentUser
  useEffect(() => {
    if (currentUser?.siteAccessibility) {
      const { siteAccessibility } = currentUser;
      const _siteOptions = siteAccessibility.map((item) => ({
        label: item.siteName,
        value: item.siteID?.toString(),
      }));
      setSiteOptions(_siteOptions);
    }
  }, [currentUser]);

  // Load contractor options
  useEffect(() => {
    const fetchContractors = async () => {
      try {
        const { data, status } = await dropdownApis.fetchContractorDropDown(
          flowTypeParam
        );
        if (status) {
          const _contractorOptions = data.map((item) => ({
            label: item.companyName,
            value: item.contractorID?.toString(),
          }));
          setContractorOptions(_contractorOptions);
        }
      } catch (error) {
        console.log("Error fetching contractors:", error);
      }
    };
    fetchContractors();
  }, [flowTypeParam]);

  // API Data States
  const [workOrderSummaryData, setWorkOrderSummaryData] = useState({
    flowData: [],
    paymentFlow: [],
  });
  const [workOrderTotalsSummary, setWorkOrderTotalsSummary] = useState({
    mobilizationRecovery: 0,
    retentionAmount: 0,
    onHoldAmount: 0,
    progressPercent: 0,
    workOrderValue: 0,
    underExecutionValue: 0,
  });
  const [workOrderStatusData, setWorkOrderStatusData] = useState([]);
  const [topWorkCategoriesData, setTopWorkCategoriesData] = useState([]);
  const [topContractorsData, setTopContractorsData] = useState([]);
  const [budgetVarianceData, setBudgetVarianceData] = useState([]);
  const [workExecutionMonitoringData, setWorkExecutionMonitoringData] =
    useState([]);
  const [pendingExecutionApprovalsData, setPendingExecutionApprovalsData] =
    useState([]);
  const [contractorSummaryData, setContractorSummaryData] = useState([]);

  // Loading States
  const [loading, setLoading] = useState({
    workOrderSummary: false,
    workOrderStatus: false,
    topWorkCategories: false,
    topContractors: false,
    budgetVariance: false,
    workExecutionMonitoring: false,
    pendingExecutionApprovals: false,
    contractorSummary: false,
  });

  // Error States
  const [errors, setErrors] = useState({
    workOrderSummary: null,
    workOrderStatus: null,
    topWorkCategories: null,
    topContractors: null,
    budgetVariance: null,
    workExecutionMonitoring: null,
    pendingExecutionApprovals: null,
    contractorSummary: null,
  });

  // Load dashboard data on component mount and filter changes
  useEffect(() => {
    loadDashboardData();
  }, [filters, flowType]);

  const loadDashboardData = async () => {
    await Promise.all([
      loadWorkOrderSummary(),
      loadWorkOrderStatus(),
      loadTopWorkCategories(),
      loadTopContractors(),
      loadBudgetVariance(),
      loadWorkExecutionMonitoring(),
      loadPendingExecutionApprovals(),
      loadContractorSummary(),
    ]);
  };

  // Build common params from filters
  const buildFilterParams = () => {
    const params = {
      flowType: flowTypeParam,
    };
    if (filters.site !== "all") {
      params.siteIds = filters.site;
    }
    if (filters.contractor !== "all") {
      params.contractorIds = filters.contractor;
    }
    if (filters.dateRange) {
      params.type = filters.dateRange;
    }
    return params;
  };

  const loadWorkOrderSummary = async () => {
    try {
      setLoading((prev) => ({ ...prev, workOrderSummary: true }));
      setErrors((prev) => ({ ...prev, workOrderSummary: null }));

      const params = buildFilterParams();

      const response = await DashboardApis.workOrderTotalsSummary(params);

      if (response.status && response.data) {
        // API response structure: response.data.data.data
        const totalsData =
          response.data?.data?.data || response.data?.data || response.data;
        if (totalsData) {
          setWorkOrderTotalsSummary({
            mobilizationRecovery: totalsData.mobilizationRecovery || 0,
            retentionAmount: totalsData.retentionAmount || 0,
            onHoldAmount: totalsData.onHoldAmount || 0,
            progressPercent: totalsData.progressPercent || 0,
            workOrderValue: totalsData.workOrderValue || 0,
            underExecutionValue: totalsData.underExecutionValue || 0,
          });
        }
      } else {
        throw new Error(
          response.message || "Failed to load work order totals summary"
        );
      }
    } catch (error) {
      console.error("Error loading work order totals summary:", error);
      setErrors((prev) => ({
        ...prev,
        workOrderSummary: error.message || "Failed to load data",
      }));
    } finally {
      setLoading((prev) => ({ ...prev, workOrderSummary: false }));
    }
  };

  const loadWorkOrderStatus = async () => {
    try {
      setLoading((prev) => ({ ...prev, workOrderStatus: true }));
      setErrors((prev) => ({ ...prev, workOrderStatus: null }));

      const response = await DashboardApis.WorkOrderStatus(buildFilterParams());

      if (response.status && response.data) {
        const transformedData = response.data.data;
        setWorkOrderStatusData(transformedData);
      } else {
        throw new Error(response.message || "Failed to load work order status");
      }
    } catch (error) {
      console.error("Error loading work order status:", error);
      setErrors((prev) => ({
        ...prev,
        workOrderStatus: error.message || "Failed to load data",
      }));
    } finally {
      setLoading((prev) => ({ ...prev, workOrderStatus: false }));
    }
  };

  const loadTopWorkCategories = async () => {
    try {
      setLoading((prev) => ({ ...prev, topWorkCategories: true }));
      setErrors((prev) => ({ ...prev, topWorkCategories: null }));

      const response = await DashboardApis.TopWorkCategories(buildFilterParams());

      if (response.status && response.data) {
        // const transformedData = response.data.map((item) => ({
        //   category: item.categoryName || item.category,
        //   value: item.orderCount || item.value || 0,
        //   percentage: item.percentage || 0,
        //   amount: item.totalAmount || item.amount || 0,
        // }));
        const transformedData = response.data.data;
        setTopWorkCategoriesData(transformedData);
      } else {
        throw new Error(
          response.message || "Failed to load top work categories"
        );
      }
    } catch (error) {
      console.error("Error loading top work categories:", error);
      setErrors((prev) => ({
        ...prev,
        topWorkCategories: error.message || "Failed to load data",
      }));
      // Fallback to mock data
      // setTopWorkCategoriesData([
      //   { category: "Civil", value: 35, percentage: 35, amount: 17500000 },
      //   { category: "Electrical", value: 28, percentage: 28, amount: 14000000 },
      //   { category: "Plumbing", value: 20, percentage: 20, amount: 10000000 },
      //   { category: "Excavation", value: 12, percentage: 12, amount: 6000000 },
      //   { category: "RMC", value: 5, percentage: 5, amount: 2500000 },
      // ]);
    } finally {
      setLoading((prev) => ({ ...prev, topWorkCategories: false }));
    }
  };

  const loadTopContractors = async () => {
    try {
      setLoading((prev) => ({ ...prev, topContractors: true }));
      setErrors((prev) => ({ ...prev, topContractors: null }));

      const response = await DashboardApis.TopContractorsbyWorkOrders(buildFilterParams());

      if (response.status && response.data) {
        // const transformedData = response.data.map((item) => ({
        //   contractor: item.contractorName || item.contractor,
        //   orderCount: item.orderCount || 0,
        //   valuePercentage: item.valuePercentage || 0,
        //   valueAmount: item.valueAmount || item.totalValue || 0,
        // }));
        const transformedData = response.data.data;
        setTopContractorsData(transformedData);
      } else {
        throw new Error(response.message || "Failed to load top contractors");
      }
    } catch (error) {
      console.error("Error loading top contractors:", error);
      setErrors((prev) => ({
        ...prev,
        topContractors: error.message || "Failed to load data",
      }));
    } finally {
      setLoading((prev) => ({ ...prev, topContractors: false }));
    }
  };

  const loadBudgetVariance = async () => {
    try {
      setLoading((prev) => ({ ...prev, budgetVariance: true }));
      setErrors((prev) => ({ ...prev, budgetVariance: null }));

      const response = await DashboardApis.BudgetVariancebyContractor(buildFilterParams());

      if (response.status && response.data) {
        // const transformedData = response.data.map((item) => ({
        //   contractor: item.contractorName || item.contractor,
        //   amendments: item.amendments || item.amendmentCount || 0,
        //   count: item.count || item.workOrderCount || 0,
        //   valuePercentage: item.valuePercentage || item.percentage || 0,
        //   valueAmount: item.valueAmount || item.totalValue || item.amount || 0,
        // }));
        const transformedData = response.data.data;
        setBudgetVarianceData(transformedData);
      } else {
        throw new Error(
          response.message || "Failed to load budget variance data"
        );
      }
    } catch (error) {
      console.error("Error loading budget variance:", error);
      setErrors((prev) => ({
        ...prev,
        budgetVariance: error.message || "Failed to load data",
      }));
    } finally {
      setLoading((prev) => ({ ...prev, budgetVariance: false }));
    }
  };

  const [workExecutionData, setWorkExecutionData] = useState({
    planning: { finalized: 65, pending: 35 },
    execution: { approved: 72, pending: 28 },
    task: { completed: 58, pending: 42 },
  });

  // Helper function to format currency amounts
  const formatCurrency = (amount) => {
    if (amount >= 10000000) {
      return `₹${(amount / 10000000).toFixed(1)}Cr`;
    } else if (amount >= 100000) {
      return `₹${(amount / 100000).toFixed(1)}L`;
    } else if (amount >= 1000) {
      return `₹${(amount / 1000).toFixed(1)}K`;
    }
    return `₹${amount}`;
  };

  // Work Order Summary Flow Chain
  const WorkOrderSummaryFlow = () => {
    // Calculate derived values
    const outstanding =
      (workOrderTotalsSummary.retentionAmount || 0) +
      (workOrderTotalsSummary.onHoldAmount || 0);
    const completedPayments =
      (workOrderTotalsSummary.workOrderValue || 0) -
      (workOrderTotalsSummary.underExecutionValue || 0) -
      outstanding;

    // Payment vs Receivables terminology depends on flow (Receivables for client only)
    const outstandingLabel = isClientFlow
      ? "Outstanding Receivables"
      : "Outstanding Payment";
    const overdueLabel = isClientFlow
      ? "Overdue Receivables"
      : "Overdue Payment";
    const completedLabel = isClientFlow
      ? "Payment Receivables"
      : "Payment Completed";

    // Map stage names to short abbreviations
    const getStageAbbreviation = (stageName) => {
      const abbreviationMap = {
        "Allocated Budget": "AB",
        "Work Orders": "WO",
        "Under Execution": "UE",
        "RA Bills Pending": "RP",
        "RA Bills Approved": "RA",
        "Outstanding Receivables": "OR",
        "Overdue Receivables": "OD",
        "Payment Receivables": "PR",
        "Outstanding Payment": "OP",
        "Overdue Payment": "OD",
        "Payment Completed": "PC",
      };
      return abbreviationMap[stageName] || "ST";
    };

    // Create flow stages from API data
    const allStages = [
      {
        stage: "Allocated Budget",
        value: workOrderTotalsSummary.workOrderValue || 0,
        color: "rgba(76, 175, 80, 0.5)",
      },
      {
        stage: "Work Orders",
        value: workOrderTotalsSummary.workOrderValue || 0,
        color: "rgba(33, 150, 243, 0.5)",
      },
      {
        stage: "Under Execution",
        value: workOrderTotalsSummary.underExecutionValue || 0,
        color: "rgba(255, 152, 0, 0.5)",
      },
      {
        stage: "RA Bills Pending",
        value: (workOrderTotalsSummary.underExecutionValue || 0) * 0.1, // Estimated
        color: "rgba(233, 30, 99, 0.5)",
      },
      {
        stage: "RA Bills Approved",
        value: (workOrderTotalsSummary.underExecutionValue || 0) * 0.4, // Estimated
        color: "rgba(156, 39, 176, 0.5)",
      },
      {
        stage: outstandingLabel,
        value: outstanding,
        color: "rgba(244, 67, 54, 0.5)",
      },
      {
        stage: overdueLabel,
        value: outstanding * 0.5, // Estimated as part of outstanding
        color: "rgba(255, 87, 34, 0.5)",
      },
      {
        stage: completedLabel,
        value: completedPayments > 0 ? completedPayments : 0,
        color: "rgba(63, 81, 181, 0.5)",
      },
    ];

    return (
      <div>
        {/* Horizontal Flow Container */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            position: "relative",
            flexWrap: "wrap",
            gap: "10px",
            marginBottom: "30px",
          }}
        >
          {allStages.map((stage, index) => (
            <React.Fragment key={index}>
              {/* Stage Node */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  position: "relative",
                  flex: "1",
                  minWidth: "120px",
                }}
              >
                {/* Stage Circle */}
                <div
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    backgroundColor: stage.color || "#3498db",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                    zIndex: 2,
                    transition: "all 0.3s ease",
                  }}
                >
                  <div
                    style={{
                      fontSize: "12px",
                      fontWeight: "bold",
                      textAlign: "center",
                      lineHeight: "1.1",
                      color: "#2c3e50",
                      textShadow: "none",
                    }}
                  >
                    {getStageAbbreviation(stage.stage)}
                  </div>
                </div>

                {/* Stage Label */}
                <div
                  style={{
                    marginTop: "10px",
                    textAlign: "center",
                    maxWidth: "100px",
                    fontSize: "20px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "12px",
                      fontWeight: "600",
                      color: "#2c3e50",
                      lineHeight: "1.2",
                      marginBottom: "4px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {stage.stage}
                  </div>

                  {/* Value Badge */}
                  <div
                    style={{
                      color: "#34495e",
                      padding: "4px 8px",
                      borderRadius: "12px",
                      fontSize: "14px",
                      fontWeight: "bold",
                      display: "inline-block",
                    }}
                  >
                    {formatCurrency(stage.value)}
                  </div>
                </div>
              </div>

              {/* Connecting Dotted Line */}
              {index < allStages.length - 1 && (
                <div
                  style={{
                    flex: "0 0 40px",
                    height: "2px",
                    background: `repeating-linear-gradient(
                    to right,
                    #bdc3c7,
                    #bdc3c7 6px,
                    transparent 6px,
                    transparent 12px
                  )`,
                    position: "relative",
                    top: "-25px",
                    zIndex: 1,
                  }}
                >
                  {/* Arrow at the end of line */}
                  <div
                    style={{
                      position: "absolute",
                      right: "-3px",
                      top: "-4px",
                      width: 0,
                      height: 0,
                      borderLeft: "6px solid #bdc3c7",
                      borderTop: "5px solid transparent",
                      borderBottom: "5px solid transparent",
                    }}
                  />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>

        {/* Summary Stats */}
        <div
          style={{
            marginTop: "30px",
            padding: "15px",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
            textAlign: "center",
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
              gap: "20px",
              justifyContent: "space-around",
            }}
          >
            <div>
              <div
                style={{
                  fontSize: "12px",
                  color: "#7f8c8d",
                  marginBottom: "4px",
                }}
              >
                Work Order Value
              </div>
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: "#2c3e50",
                }}
              >
                {formatCurrency(workOrderTotalsSummary.workOrderValue || 0)}
              </div>
            </div>

            <div>
              <div
                style={{
                  fontSize: "12px",
                  color: "#7f8c8d",
                  marginBottom: "4px",
                }}
              >
                Under Execution
              </div>
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: "#3498db",
                }}
              >
                {formatCurrency(
                  workOrderTotalsSummary.underExecutionValue || 0
                )}
                <span
                  style={{
                    fontSize: "12px",
                    color: "#7f8c8d",
                    marginLeft: "4px",
                  }}
                >
                  ({(workOrderTotalsSummary.progressPercent || 0).toFixed(1)}%)
                </span>
              </div>
            </div>

            <div>
              <div
                style={{
                  fontSize: "12px",
                  color: "#7f8c8d",
                  marginBottom: "4px",
                }}
              >
                Progress
              </div>
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: "#27ae60",
                }}
              >
                {(workOrderTotalsSummary.progressPercent || 0).toFixed(2)}%
              </div>
            </div>

            <div>
              <div
                style={{
                  fontSize: "12px",
                  color: "#7f8c8d",
                  marginBottom: "4px",
                }}
              >
                Retention Amount
              </div>
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: "#f39c12",
                }}
              >
                {formatCurrency(workOrderTotalsSummary.retentionAmount || 0)}
              </div>
            </div>

            <div>
              <div
                style={{
                  fontSize: "12px",
                  color: "#7f8c8d",
                  marginBottom: "4px",
                }}
              >
                On Hold Amount
              </div>
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: "#e67e22",
                }}
              >
                {formatCurrency(workOrderTotalsSummary.onHoldAmount || 0)}
              </div>
            </div>

            <div>
              <div
                style={{
                  fontSize: "12px",
                  color: "#7f8c8d",
                  marginBottom: "4px",
                }}
              >
                Mobilization Recovery
              </div>
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: "#9b59b6",
                }}
              >
                {formatCurrency(
                  workOrderTotalsSummary.mobilizationRecovery || 0
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Work Order Status Pie Chart
  const WorkOrderStatusChart = () => {
    const chartRef = React.useRef(null);

    useEffect(() => {
      if (chartRef.current && workOrderStatusData.length > 0) {
        const chart = echarts.init(chartRef.current);
        const option = {
          tooltip: {
            trigger: "item",
            formatter: "{b}: {c} ({d}%)",
          },
          legend: {
            orient: "vertical",
            left: "right",
            textStyle: { fontSize: 10 },
          },
          series: [
            {
              type: "pie",
              radius: ["40%", "70%"],
              center: ["35%", "50%"],
              data: workOrderStatusData.map((item) => ({
                name: item.name,
                value: item.value,
                itemStyle: { color: item.color },
              })),
              label: {
                formatter: "{b}\n{c}",
              },
            },
          ],
        };
        chart.setOption(option);
        return () => chart.dispose();
      }
    }, [workOrderStatusData]);

    // Show "No Data Found" if empty
    if (!workOrderStatusData || workOrderStatusData.length === 0) {
      return (
        <div
          style={{
            height: 260,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Empty description="No data found" />
        </div>
      );
    }

    return <div ref={chartRef} style={{ width: "100%", height: "300px" }} />;
  };

  // Top Work Categories Chart
  const TopWorkCategoriesChart = () => {
    const chartRef = React.useRef(null);

    useEffect(() => {
      if (chartRef.current && topWorkCategoriesData.length > 0) {
        const chart = echarts.init(chartRef.current);
        const option = {
          tooltip: {
            trigger: "axis",
            formatter: (params) => {
              const dataIndex = params[0].dataIndex;
              const item = topWorkCategoriesData[dataIndex];
              const formattedAmount = formatCurrency(item.amount);
              return `${params[0].name}: ${formattedAmount} (${item.percentage}%)`;
            },
          },
          grid: {
            left: "15%",
            right: "10%",
            bottom: "10%",
            top: "10%",
          },
          xAxis: {
            type: "value",
            axisLabel: {
              formatter: (value) => {
                if (value >= 10000000) {
                  return `₹${(value / 10000000).toFixed(1)}Cr`;
                } else if (value >= 100000) {
                  return `₹${(value / 100000).toFixed(1)}L`;
                } else if (value >= 1000) {
                  return `₹${(value / 1000).toFixed(1)}K`;
                }
                return `₹${value}`;
              },
            },
          },
          yAxis: {
            type: "category",
            data: topWorkCategoriesData.map((item) => item.category),
            axisLabel: {
              width: 100,
              overflow: "truncate",
              ellipsis: "...",
              formatter: (value) => {
                // Truncate long labels and add ellipsis
                const maxLength = 15;
                if (value.length > maxLength) {
                  return value.substring(0, maxLength) + "...";
                }
                return value;
              },
            },
            triggerEvent: true,
          },
          series: [
            {
              type: "bar",
              data: topWorkCategoriesData.map((item) => item.amount),
              itemStyle: {
                color: (params) => {
                  const colors = [
                    "#4ecdc4",
                    "#45b7d1",
                    "#96ceb4",
                    "#feca57",
                    "#eed08eff",
                  ];
                  return colors[params.dataIndex];
                },
              },
              label: {
                show: true,
                position: "right",
                formatter: (params) => {
                  const item = topWorkCategoriesData[params.dataIndex];
                  return formatCurrency(item.amount);
                },
                fontSize: 10,
                color: "#2c3e50",
              },
            },
          ],
        };
        chart.setOption(option);

        // Add hover tooltip for y-axis labels
        chart.on("mouseover", { componentType: "yAxis" }, function (params) {
          const fullName = topWorkCategoriesData[params.dataIndex]?.category;
          if (fullName && fullName.length > 15) {
            chart.dispatchAction({
              type: "showTip",
              seriesIndex: 0,
              dataIndex: params.dataIndex,
            });
          }
        });

        return () => chart.dispose();
      }
    }, [topWorkCategoriesData]);

    // Show "No Data Found" if empty
    if (!topWorkCategoriesData || topWorkCategoriesData.length === 0) {
      return (
        <div
          style={{
            height: 260,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Empty description="No data found" />
        </div>
      );
    }

    return <div ref={chartRef} style={{ width: "100%", height: "300px" }} />;
  };

  const TopContractorsTable = () => {
    const columns = [
      // {
      //   title: 'Rank',
      //   key: 'rank',
      //   width: 60,
      //   align: 'center',
      //   render: (text, record, index) => (
      //     <span style={{
      //       backgroundColor: '#f39c12',
      //       color: 'white',
      //       padding: '4px 8px',
      //       borderRadius: '50%',
      //       fontSize: '12px',
      //       fontWeight: 'bold'
      //     }}>
      //       {index + 1}
      //     </span>
      //   ),
      // },
      {
        title: isClientFlow ? "Client Name" : "Contractor Name",
        dataIndex: "contractor",
        key: "contractor",
        render: (text) => (
          <>
            <strong style={{ color: "#2c3e50", fontSize: "14px" }}>
              {text}
            </strong>
            <div
              style={{
                fontSize: "10px",
                color: "#7f8c8d",
                marginTop: "2px",
              }}
            >
              Active
            </div>
          </>
        ),
      },
      {
        title: "Order Count",
        dataIndex: "orderCount",
        key: "orderCount",
        align: "center",
        sorter: (a, b) => a.orderCount - b.orderCount,
        render: (count) => (
          <span
          // style={{
          //   display: "flex",
          //   alignItems: "center",
          //   gap: 8,
          //   backgroundColor: "#3498db",
          //   color: "white",
          //   padding: "6px 12px",
          //   borderRadius: "8px",
          //   fontWeight: "bold",
          //   fontSize: "14px",
          // }}
          >
            {count}
          </span>
        ),
      },
      {
        title: "Value",
        dataIndex: "valueAmount",
        key: "valueAmount",
        align: "center",
        sorter: (a, b) => a.valueAmount - b.valueAmount,
        render: (amount, record) => (
          <div>
            <div
              style={{
                fontWeight: "bold",
                color: "#2c3e50",
                fontSize: "13px",
                marginBottom: "4px",
              }}
            >
              {formatCurrency(amount)}
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Progress
                percent={record.valuePercentage}
                size="small"
                strokeColor="#27ae60"
                style={{ flex: 1, marginRight: "8px" }}
                showInfo={false}
              />
              <span
                style={{
                  fontWeight: "bold",
                  color: "#27ae60",
                  fontSize: "11px",
                }}
              >
                {record.valuePercentage}%
              </span>
            </div>
          </div>
        ),
      },
    ];

    const dataSource = topContractorsData?.slice(0, 5)?.map((item, index) => ({
      key: index,
      contractor: item.contractor,
      orderCount: item.orderCount,
      valuePercentage: item.valuePercentage,
      valueAmount: item.valueAmount,
    }));
    if (!topContractorsData || topContractorsData.length === 0) {
      return (
        <div
          style={{
            height: 260,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Empty description="No data found" />
        </div>
      );
    } else {
      return (
        <Table
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          size="small"
          bordered={false}
        />
      );
    }
  };

  // Budget Variance Table
  const BudgetVarianceTable = () => {
    const columns = [
      {
        title: isClientFlow ? "Client" : "Contractor",
        dataIndex: "contractor",
        key: "contractor",
        render: (text) => (
          <>
            <strong style={{ color: "#2c3e50", fontSize: "14px" }}>
              {text}
            </strong>
            <div
              style={{
                fontSize: "10px",
                color: "#7f8c8d",
                marginTop: "2px",
              }}
            >
              Active
            </div>
          </>
        ),
      },
      {
        title: "Amendments Count",
        dataIndex: "count",
        key: "count",
        align: "center",
        sorter: (a, b) => a.count - b.count,
        render: (count) => (
          <span
            style={{
              backgroundColor: "#4ecdc4",
              color: "white",
              padding: "6px 12px",
              borderRadius: "8px",
              fontWeight: "bold",
              fontSize: "14px",
            }}
          >
            {count}
          </span>
        ),
      },
      {
        title: "Value",
        dataIndex: "valueAmount",
        key: "valueAmount",
        align: "center",
        sorter: (a, b) => a.valueAmount - b.valueAmount,
        render: (amount, record) => (
          <div>
            <div
              style={{
                fontWeight: "bold",
                color: "#2c3e50",
                fontSize: "13px",
                marginBottom: "4px",
              }}
            >
              {formatCurrency(amount)}
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Progress
                percent={record.valuePercentage}
                size="small"
                strokeColor="#feca57"
                style={{ flex: 1, marginRight: "8px" }}
                showInfo={false}
              />
              <span
                style={{
                  fontWeight: "bold",
                  color: "#feca57",
                  fontSize: "11px",
                }}
              >
                {record.valuePercentage}%
              </span>
            </div>
          </div>
        ),
      },
    ];

    const dataSource = budgetVarianceData?.slice(0, 5)?.map((item, index) => ({
      key: index,
      contractor: item.contractor,
      amendments: item.amendments,
      count: item.count,
      valuePercentage: item.valuePercentage,
      valueAmount: item.valueAmount,
    }));

    if (!budgetVarianceData || budgetVarianceData.length === 0) {
      return (
        <div
          style={{
            height: 260,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Empty description="No data found" />
        </div>
      );
    } else {
      return (
        <Table
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          size="small"
          bordered={false}
          // style={{ height: "100%" }}
        />
      );
    }
  };

  // Work Execution Progress Bars
  const WorkExecutionProgress = () => (
    <div style={{ padding: "20px" }}>
      <Row gutter={[16, 16]}>
        <Col span={8}>
          <h4>Planning/Finalized Week</h4>
          <Progress
            percent={workExecutionData.planning.finalized}
            strokeColor="#4ecdc4"
            format={() => `${workExecutionData.planning.finalized}%`}
          />
          <div style={{ marginTop: "10px", fontSize: "12px", color: "#666" }}>
            Pending: {workExecutionData.planning.pending}%
          </div>
        </Col>
        <Col span={8}>
          <h4>Execution Approval</h4>
          <Progress
            percent={workExecutionData.execution.approved}
            strokeColor="#45b7d1"
            format={() => `${workExecutionData.execution.approved}%`}
          />
          <div style={{ marginTop: "10px", fontSize: "12px", color: "#666" }}>
            Pending: {workExecutionData.execution.pending}%
          </div>
        </Col>
        <Col span={8}>
          <h4>Task</h4>
          <Progress
            percent={workExecutionData.task.completed}
            strokeColor="#96ceb4"
            format={() => `${workExecutionData.task.completed}%`}
          />
          <div style={{ marginTop: "10px", fontSize: "12px", color: "#666" }}>
            Pending: {workExecutionData.task.pending}%
          </div>
        </Col>
      </Row>
    </div>
  );

  // Complete code for Work Execution Components

  const loadWorkExecutionMonitoring = async () => {
    try {
      setLoading((prev) => ({ ...prev, workExecutionMonitoring: true }));
      setErrors((prev) => ({ ...prev, workExecutionMonitoring: null }));

      const response = await DashboardApis.WorkExecutionMonitoring(buildFilterParams());

      if (response.status && response.data) {
        // const transformedData = response.data.map((item) => ({
        //   contractor: item.contractorName || item.contractor,
        //   plannedFinalized: item.plannedFinalized || item.plannedWork || 0,
        //   executed: item.executed || item.executedWork || 0,
        // }));
        const transformedData = response.data.data;
        setWorkExecutionMonitoringData(transformedData);
      } else {
        throw new Error(
          response.message || "Failed to load work execution monitoring data"
        );
      }
    } catch (error) {
      console.error("Error loading work execution monitoring:", error);
      setErrors((prev) => ({
        ...prev,
        workExecutionMonitoring: error.message || "Failed to load data",
      }));
    } finally {
      setLoading((prev) => ({ ...prev, workExecutionMonitoring: false }));
    }
  };

  const loadPendingExecutionApprovals = async () => {
    try {
      setLoading((prev) => ({ ...prev, pendingExecutionApprovals: true }));
      setErrors((prev) => ({ ...prev, pendingExecutionApprovals: null }));

      const response = await DashboardApis.PendingExecutionApprovals(buildFilterParams());

      if (response.status && response.data) {
        // const transformedData = response.data.map((item, index) => ({
        //   key: item.id || index + 1,
        //   contractor: item.contractorName || item.contractor,
        //   workOrder: item.workOrderNumber || item.workOrder,
        //   task: item.taskName || item.task,
        //   quantity: item.quantity || 0,
        //   executedQty: item.executedQuantity || item.executedQty || 0,
        //   pendingDays: item.pendingDays || 0,
        // }));
        const transformedData = response.data.data?.slice(0, 5);
        setPendingExecutionApprovalsData(transformedData);
      } else {
        throw new Error(
          response.message || "Failed to load pending execution approvals"
        );
      }
    } catch (error) {
      console.error("Error loading pending execution approvals:", error);
      setErrors((prev) => ({
        ...prev,
        pendingExecutionApprovals: error.message || "Failed to load data",
      }));
    } finally {
      setLoading((prev) => ({ ...prev, pendingExecutionApprovals: false }));
    }
  };

  const loadContractorSummary = async () => {
    try {
      setLoading((prev) => ({ ...prev, contractorSummary: true }));
      setErrors((prev) => ({ ...prev, contractorSummary: null }));

      const response = await DashboardApis.ContractorSummary(buildFilterParams());

      if (response.status && response.data) {
        // const transformedData = response.data.map((item) => ({
        //   contractor: item.contractorName || item.contractor,
        //   woValue: item.workOrderValue || item.woValue || 0,
        //   percentExecuted:
        //     item.percentExecuted || item.executionPercentage || 0,
        //   raBillsAmount: item.raBillsAmount || item.raBillValue || 0,
        //   paymentsAmount: item.paymentsAmount || item.paidAmount || 0,
        //   outstanding: item.outstanding || item.outstandingAmount || 0,
        //   overdue: item.overdue || item.overdueAmount || 0,
        //   avgAgingDays: item.averageAgingDays || item.avgAgingDays || 0,
        // }));
        const transformedData = response.data.data;
        setContractorSummaryData(transformedData);
      } else {
        throw new Error(
          response.message || "Failed to load contractor summary"
        );
      }
    } catch (error) {
      console.error("Error loading contractor summary:", error);
      setErrors((prev) => ({
        ...prev,
        contractorSummary: error.message || "Failed to load data",
      }));
    } finally {
      setLoading((prev) => ({ ...prev, contractorSummary: false }));
    }
  };

  // ============================================================================
  // 1. WORK EXECUTION MONITORING CHART
  // ============================================================================
  const WorkExecutionMonitoringChart = () => {
    const chartRef = React.useRef(null);

    useEffect(() => {
      if (chartRef.current && workExecutionMonitoringData.length > 0) {
        const chart = echarts.init(chartRef.current);
        const option = {
          // title: {
          //   text: "Work Execution Monitoring",
          //   left: "center",
          //   textStyle: {
          //     fontSize: 16,
          //     fontWeight: "bold",
          //     color: "#2c3e50",
          //   },
          // },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
            },
            formatter: function (params) {
              let result = `<strong>${params[0].axisValue}</strong><br/>`;
              params.forEach((param) => {
                result += `${param.seriesName}: ${param.value}%<br/>`;
              });
              return result;
            },
          },
          legend: {
            data: ["Executed Work"],
            bottom: 0,
            textStyle: {
              fontSize: 12,
            },
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "15%",
            top: "15%",
            containLabel: true,
          },
          xAxis: {
            type: "category",
            data: workExecutionMonitoringData.map((item) => item.contractor),
            axisLabel: {
              fontSize: 12,
              fontWeight: "bold",
            },
          },
          yAxis: {
            type: "value",
            max: 100,
            min: 0,
            axisLabel: {
              formatter: "{value}%",
              fontSize: 12,
            },
            name: "Work Progress (%)",
            nameTextStyle: {
              fontSize: 12,
              color: "#666",
            },
          },
          series: [
            {
              name: "Executed Work",
              type: "bar",
              data: workExecutionMonitoringData.map((item) => item.executed),
              itemStyle: {
                color: "#4ecdc4",
                borderRadius: [2, 2, 0, 0],
              },
              barWidth: "50%",
              label: {
                show: true,
                position: "top",
                formatter: "{c}%",
                fontSize: 10,
                color: "#2c3e50",
                fontWeight: "bold",
              },
            },
          ],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        };

        chart.setOption(option);

        // Handle window resize
        const handleResize = () => {
          chart.resize();
        };
        window.addEventListener("resize", handleResize);

        return () => {
          window.removeEventListener("resize", handleResize);
          chart.dispose();
        };
      }
    }, [workExecutionMonitoringData]);

    // Show "No Data Found" if empty
    if (
      !workExecutionMonitoringData ||
      workExecutionMonitoringData.length === 0
    ) {
      return (
        <div
          style={{
            height: 260,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Empty description="No data found" />
        </div>
      );
    }

    return (
      <div>
        <div ref={chartRef} style={{ width: "100%", height: "320px" }} />
      </div>
    );
  };

  // ============================================================================
  // 2. PENDING EXECUTION APPROVALS TABLE
  // ============================================================================
  const PendingExecutionApprovalsTable = () => {
    const columns = [
      {
        title: isClientFlow ? "Client" : "Contractor",
        dataIndex: "contractor",
        key: "contractor",
        width: 120,
        render: (text) => (
          <Tooltip title={text} placement="topLeft">
            <div>
              <strong
                style={{
                  color: "#2c3e50",
                  fontSize: "13px",
                  display: "block",
                  maxWidth: "100px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {text}
              </strong>
              <div
                style={{
                  fontSize: "10px",
                  color: "#7f8c8d",
                  marginTop: "2px",
                }}
              >
                Active
              </div>
            </div>
          </Tooltip>
        ),
        // filters: [
        //   { text: "Contractor 1", value: "Contractor 1" },
        //   { text: "Contractor 2", value: "Contractor 2" },
        //   { text: "Contractor 3", value: "Contractor 3" },
        //   { text: "Contractor 4", value: "Contractor 4" },
        // ],
        // onFilter: (value, record) => record.contractor.includes(value),
      },
      {
        title: "WO#",
        dataIndex: "workOrder",
        key: "workOrder",
        width: 100,
        render: (text) => (
          <span
            style={{
              backgroundColor: "#e3f2fd",
              padding: "4px 8px",
              borderRadius: "4px",
              fontSize: "11px",
              fontWeight: "bold",
              color: "#1976d2",
            }}
          >
            {text}
          </span>
        ),
      },
      {
        title: "Task",
        dataIndex: "task",
        key: "task",
        width: 120,
        render: (text) => (
          <div
            style={{
              fontSize: "12px",
              color: "#2c3e50",
              lineHeight: "1.3",
            }}
          >
            {text}
          </div>
        ),
      },
      {
        title: "QTY",
        dataIndex: "quantity",
        key: "quantity",
        width: 60,
        align: "center",
        // sorter: (a, b) => a.quantity - b.quantity,
        render: (qty) => (
          <span
            style={{
              fontWeight: "bold",
              color: "#2c3e50",
            }}
          >
            {qty}
          </span>
        ),
      },
      {
        title: "Executed QTY",
        dataIndex: "executedQty",
        key: "executedQty",
        width: 120,
        align: "center",
        // sorter: (a, b) =>
        //   a.executedQty / a.quantity - b.executedQty / b.quantity,
        render: (executedQty, record) => {
          const percentage = Math.round((executedQty / record.quantity) * 100);
          return (
            <div>
              {/* <div
                style={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  marginBottom: "4px",
                  color:
                    percentage >= 80
                      ? "#27ae60"
                      : percentage >= 60
                      ? "#f39c12"
                      : "#e74c3c",
                }}
              >
                {executedQty}/{record.quantity}
              </div> */}
              {/* <Progress
                percent={percentage}
                size="small"
                strokeColor={
                  percentage >= 80
                    ? "#27ae60"
                    : percentage >= 60
                    ? "#f39c12"
                    : "#e74c3c"
                }
                showInfo={false}
                style={{ marginBottom: "2px" }}
              /> */}
              <div
              // style={{
              //   fontSize: "10px",
              //   color: "#7f8c8d",
              // }}
              >
                {percentage}
              </div>
            </div>
          );
        },
      },
      {
        title: "Pending Days",
        dataIndex: "pendingDays",
        key: "pendingDays",
        width: 150,
        align: "center",
        // sorter: (a, b) => a.pendingDays - b.pendingDays,
        render: (days) => {
          let color = "#27ae60";
          let bgColor = "#d5f4e6";
          let status = "On Track";

          if (days > 10) {
            color = "#e74c3c";
            bgColor = "#ffeaea";
            status = "Critical";
          } else if (days > 5) {
            color = "#f39c12";
            bgColor = "#fff3cd";
            status = "Warning";
          }

          return (
            <div>
              <span
              // style={{
              //   backgroundColor: color,
              //   color: "white",
              //   padding: "4px 8px",
              //   borderRadius: "12px",
              //   fontSize: "11px",
              //   fontWeight: "bold",
              //   display: "inline-block",
              //   marginBottom: "2px",
              // }}
              >
                {days} days
              </span>
              {/* <div
                style={{
                  fontSize: "9px",
                  color: color,
                  fontWeight: "bold",
                }}
              >
                {status}
              </div> */}
            </div>
          );
        },
      },
    ];

    if (pendingExecutionApprovalsData.length > 0) {
      return (
        <div>
          <Table
            columns={columns}
            dataSource={pendingExecutionApprovalsData}
            pagination={false}
            // pagination={{
            //   pageSize: 5,
            //   showSizeChanger: false,
            //   showQuickJumper: true,
            //   showTotal: (total, range) =>
            //     `${range[0]}-${range[1]} of ${total} items`,
            // }}
            size="small"
            // scroll={{ y: 250 }}
            bordered={false}
            // rowClassName={(record) => {
            //   if (record.pendingDays > 10) return "critical-row";
            //   if (record.pendingDays > 5) return "warning-row";
            //   return "normal-row";
            // }}
          />

          <style jsx>{`
            .critical-row {
              background-color: #ffeaea !important;
            }
            .warning-row {
              background-color: #fff3cd !important;
            }
            .normal-row {
              background-color: #f8f9fa !important;
            }
          `}</style>
        </div>
      );
    } else {
      return (
        <div
          style={{
            height: 260,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Empty description="No data found" />
        </div>
      );
    }
  };

  // ============================================================================
  // 3. CONTRACTOR SUMMARY CARDS
  // ============================================================================
  const ContractorSummaryCarousel = () => {
    // Payment vs Receivables terminology depends on flow (Receivables for client only)
    const paymentsLabel = isClientFlow ? "Receivables Payments" : "Payments";
    const outstandingLabel = isClientFlow
      ? "Outstanding Receivables"
      : "Outstanding Payment";
    const overdueLabel = isClientFlow
      ? "Overdue Receivables"
      : "Overdue Payment";

    const formatCurrency = (amount) => {
      if (amount >= 10000000) {
        return `₹${(amount / 10000000).toFixed(1)}Cr`;
      } else if (amount >= 100000) {
        return `₹${(amount / 100000).toFixed(1)}L`;
      } else if (amount >= 1000) {
        return `₹${(amount / 1000).toFixed(1)}K`;
      }
      return `₹${amount}`;
    };

    const getStatusColor = (contractor, index) => {
      const colors = ["#3498db", "#e74c3c", "#27ae60", "#f39c12", "#9b59b6"];
      return colors[index % colors.length];
    };

    const getPerformanceRating = (percentExecuted, avgAgingDays) => {
      if (percentExecuted >= 80 && avgAgingDays <= 15)
        return { rating: "Excellent", color: "#27ae60" };
      if (percentExecuted >= 70 && avgAgingDays <= 20)
        return { rating: "Good", color: "#f39c12" };
      if (percentExecuted >= 60) return { rating: "Average", color: "#e67e22" };
      return { rating: "Poor", color: "#e74c3c" };
    };

    // Custom arrow components
    const CustomPrevArrow = (props) => {
      const { onClick } = props;
      return (
        <div
          onClick={onClick}
          style={{
            position: "absolute",
            left: "-10px",
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 10,
            backgroundColor: "white",
            borderRadius: "50%",
            width: "30px",
            height: "30px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            // boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "white";
            e.currentTarget.style.transform = "translateY(-50%) scale(1.1)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "white";
            e.currentTarget.style.transform = "translateY(-50%) scale(1)";
          }}
        >
          <span
            style={{ color: "#1890ff", fontSize: "14px", fontWeight: "bold" }}
          >
            ❮
          </span>
        </div>
      );
    };

    const CustomNextArrow = (props) => {
      const { onClick } = props;
      return (
        <div
          onClick={onClick}
          style={{
            position: "absolute",
            right: "-10px",
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 10,
            backgroundColor: "white",
            borderRadius: "50%",
            width: "30px",
            height: "30px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            // boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "white";
            e.currentTarget.style.transform = "translateY(-50%) scale(1.1)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "white";
            e.currentTarget.style.transform = "translateY(-50%) scale(1)";
          }}
        >
          <span
            style={{ color: "#1890ff", fontSize: "14px", fontWeight: "bold" }}
          >
            ❯
          </span>
        </div>
      );
    };

    // Show "No Data Found" if empty
    if (!contractorSummaryData || contractorSummaryData.length === 0) {
      return (
        <div
          style={{
            height: 260,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Empty description="No data found" />
        </div>
      );
    }

    // Custom carousel settings
    const dataCount = contractorSummaryData.length;
    const carouselSettings = {
      dots: true,
      infinite: dataCount > 3,
      speed: 500,
      slidesToShow: Math.min(dataCount, 3),
      slidesToScroll: 1,
      autoplay: dataCount > 3,
      autoplaySpeed: 4000,
      arrows: dataCount > 3,
      prevArrow: <CustomPrevArrow />,
      nextArrow: <CustomNextArrow />,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: Math.min(dataCount, 2),
            slidesToScroll: 1,
            infinite: dataCount > 2,
            arrows: dataCount > 2,
            prevArrow: <CustomPrevArrow />,
            nextArrow: <CustomNextArrow />,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: dataCount > 1,
            arrows: dataCount > 1,
            prevArrow: <CustomPrevArrow />,
            nextArrow: <CustomNextArrow />,
          },
        },
      ],
    };

    return (
      <div style={{ padding: "0", position: "relative" }}>
        <Carousel {...carouselSettings}>
          {contractorSummaryData.map((contractor, index) => {
            const performance = getPerformanceRating(
              contractor.percentExecuted,
              contractor.avgAgingDays
            );
            const statusColor = getStatusColor(contractor, index);

            return (
              <div key={index} style={{ padding: "0", margin: "0" }}>
                <Card
                  title={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span style={{ color: "#2c3e50", fontSize: "16px" }}>
                        {contractor.contractor}
                      </span>
                      {/* <span
                        style={{
                          backgroundColor: performance.color,
                          color: "white",
                          padding: "2px 8px",
                          borderRadius: "8px",
                          fontSize: "10px",
                          fontWeight: "bold",
                        }}
                      >
                        {performance.rating}
                      </span> */}
                    </div>
                  }
                  size="small"
                  style={{
                    borderLeft: `4px solid ${statusColor}`,
                    height: "320px",
                    boxShadow: "0 3px 8px rgba(0,0,0,0.12)",
                    borderRadius: "8px",
                    // margin: "0 auto",
                    width: "100%",
                    maxWidth: "460px",
                  }}
                  headStyle={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "8px 8px 0 0",
                  }}
                >
                  <div style={{ fontSize: "13px", lineHeight: "1.4" }}>
                    {/* WO Value */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "8px",
                        padding: "6px",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "4px",
                      }}
                    >
                      <span>
                        <strong>WO Value:</strong>
                      </span>
                      <span
                        style={{
                          fontWeight: "bold",
                          color: "#2c3e50",
                          fontSize: "13px",
                        }}
                      >
                        {formatCurrency(contractor.woValue)}
                      </span>
                    </div>

                    {/* Execution Progress */}
                    <div style={{ marginBottom: "10px" }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "4px",
                        }}
                      >
                        <span>
                          <strong>% Executed:</strong>
                        </span>
                        <span
                          style={{
                            fontWeight: "bold",
                            color: statusColor,
                            fontSize: "13px",
                          }}
                        >
                          {contractor.percentExecuted}%
                        </span>
                      </div>
                      <Progress
                        percent={contractor.percentExecuted}
                        size="small"
                        strokeColor={statusColor}
                        style={{ marginTop: "4px" }}
                        showInfo={false}
                      />
                      <div
                        style={{
                          fontSize: "12px",
                          color: "#7f8c8d",
                          textAlign: "right",
                          marginTop: "4px",
                        }}
                      >
                        {formatCurrency(
                          (contractor.woValue * contractor.percentExecuted) /
                            100
                        )}{" "}
                        completed
                      </div>
                    </div>

                    {/* RA Bills and Payments */}
                    <Row gutter={8} style={{ marginBottom: "8px" }}>
                      <Col span={12}>
                        <div
                          style={{
                            backgroundColor: "#e8f5e8",
                            padding: "6px",
                            borderRadius: "4px",
                            textAlign: "center",
                          }}
                        >
                          <div
                            style={{
                              fontSize: "13px",
                              color: "#666",
                              marginBottom: "1px",
                            }}
                          >
                            RA Bills
                          </div>
                          <div
                            style={{
                              fontWeight: "bold",
                              fontSize: "13px",
                              color: "#27ae60",
                            }}
                          >
                            {formatCurrency(contractor.raBillsAmount)}
                          </div>
                        </div>
                      </Col>
                      <Col span={12}>
                        <div
                          style={{
                            backgroundColor: "#e3f2fd",
                            padding: "6px",
                            borderRadius: "4px",
                            textAlign: "center",
                          }}
                        >
                          <div
                            style={{
                              fontSize: "13px",
                              color: "#666",
                              marginBottom: "1px",
                            }}
                          >
                            {paymentsLabel}
                          </div>
                          <div
                            style={{
                              fontWeight: "bold",
                              fontSize: "13px",
                              color: "#3498db",
                            }}
                          >
                            {formatCurrency(contractor.paymentsAmount)}
                          </div>
                        </div>
                      </Col>
                    </Row>

                    {/* Financial Details */}
                    <div
                      style={{
                        borderTop: "1px solid #eee",
                        paddingTop: "6px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "4px",
                        }}
                      >
                        <span>
                          <strong>{outstandingLabel}:</strong>
                        </span>
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "#f39c12",
                            fontSize: "13px",
                          }}
                        >
                          {formatCurrency(contractor.outstanding)}
                        </span>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "4px",
                        }}
                      >
                        <span>
                          <strong>{overdueLabel}:</strong>
                        </span>
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "#e74c3c",
                            fontSize: "13px",
                          }}
                        >
                          {formatCurrency(contractor.overdue)}
                        </span>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginTop: "6px",
                          paddingTop: "4px",
                          borderTop: "1px solid #eee",
                        }}
                      >
                        <span>
                          <strong>Avg Aging:</strong>
                        </span>
                        <span
                          style={{
                            backgroundColor:
                              contractor.avgAgingDays > 20
                                ? "#e74c3c"
                                : contractor.avgAgingDays > 15
                                ? "#f39c12"
                                : "#27ae60",
                            color: "white",
                            padding: "3px 8px",
                            borderRadius: "10px",
                            fontSize: "13px",
                            fontWeight: "bold",
                          }}
                        >
                          {contractor.avgAgingDays} days
                        </span>
                      </div>
                    </div>
                  </div>
                </Card>
              </div>
            );
          })}
        </Carousel>
      </div>
    );
  };

  return (
    <React.Fragment>
      <Head title="projects dashboard" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Work Order Dashboard</BlockTitle>
              <BlockDes className="text-soft">
                <p>Welcome to Procurex.</p>
              </BlockDes>
            </BlockHeadContent>
            <BlockHeadContent>
              <Row gutter={16} align="middle">
                <Col>
                  <label style={{ marginRight: 8 }}>View As:</label>
                  <RadioGroup
                    value={flowType}
                    onChange={(e) => {
                      const newFlowType = e.target.value;
                      const newSearchParams = new URLSearchParams(searchParams);
                      newSearchParams.set("flowType", newFlowType);
                      setSearchParams(newSearchParams);
                    }}
                    buttonStyle="solid"
                    style={{ marginRight: 16 }}
                  >
                    <RadioButton value="client">Client</RadioButton>
                    <RadioButton value="contractor">Contractor</RadioButton>
                  </RadioGroup>
                </Col>
                <Col>
                  <label style={{ marginRight: 8 }}>Site:</label>
                  <Select
                    value={filters.site}
                    style={{ width: 200 }}
                    onChange={(value) =>
                      setFilters({ ...filters, site: value })
                    }
                  >
                    <Option value="all">All Sites</Option>
                    {siteOptions.map((site) => (
                      <Option key={site.value} value={site.value}>
                        {site.label}
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col>
                  <label style={{ marginRight: 8 }}>Contractor:</label>
                  <Select
                    value={filters.contractor}
                    style={{ width: 200 }}
                    onChange={(value) =>
                      setFilters({ ...filters, contractor: value })
                    }
                  >
                    <Option value="all">All Contractors</Option>
                    {contractorOptions.map((contractor) => (
                      <Option key={contractor.value} value={contractor.value}>
                        {contractor.label}
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col>
                  <label style={{ marginRight: 8 }}>Period:</label>
                  <Select
                    value={filters.dateRange}
                    style={{ width: 150 }}
                    onChange={(value) =>
                      setFilters({ ...filters, dateRange: value })
                    }
                  >
                    <Option value="month">Month</Option>
                    <Option value="quarter">Quarter</Option>
                    <Option value="year">Year</Option>
                  </Select>
                </Col>
                {/* <Col>
                  <Button
                    type="primary"
                    icon={<ReloadOutlined />}
                    onClick={loadDashboardData}
                    loading={Object.values(loading).some((l) => l)}
                  >
                    Refresh
                  </Button>
                </Col> */}
              </Row>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        {/* Work Order Summary - Full Width */}
        <Row gutter={16} style={{ marginBottom: "20px" }}>
          <Col xs={24}>
            <Card
              title="Work Order Summary"
              bordered={false}
              style={{ minHeight: "300px" }}
            >
              {loading.workOrderSummary ? (
                <div style={{ textAlign: "center", padding: "50px" }}>
                  <Spin size="large" />
                  <div style={{ marginTop: "16px" }}>
                    Loading Work Order Summary...
                  </div>
                </div>
              ) : errors.workOrderSummary ? (
                <Alert
                  message="Error Loading Data"
                  description={errors.workOrderSummary}
                  type="error"
                  showIcon
                  style={{ margin: "20px 0" }}
                />
              ) : null}
              <WorkOrderSummaryFlow />
            </Card>
          </Col>
        </Row>

        <Row gutter={16} style={{ marginBottom: "20px" }}>
          <Col xs={24} lg={12}>
            <Card title="Work Order Status" style={{ height: "400px" }}>
              {loading.workOrderStatus ? (
                <div style={{ textAlign: "center", padding: "50px" }}>
                  <Spin size="large" />
                  <div style={{ marginTop: "16px" }}>
                    Loading Work Order Status...
                  </div>
                </div>
              ) : errors.workOrderStatus ? (
                <Alert
                  message="Error Loading Data"
                  description={errors.workOrderStatus}
                  type="error"
                  showIcon
                  style={{ margin: "20px 0" }}
                />
              ) : null}
              <WorkOrderStatusChart />
            </Card>
          </Col>
          {/* Top Work Categories */}
          <Col xs={24} lg={12}>
            <Card
              title={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span>Top Work Categories</span>
                  <a
                    href="#"
                    style={{
                      color: "#cec4c4ff",
                      cursor: "not-allowed",
                      fontSize: "12px",
                      textDecoration: "none",
                    }}
                    onClick={(e) => e.preventDefault()}
                  >
                    View More
                  </a>
                </div>
              }
              style={{ height: "400px" }}
            >
              {loading.topWorkCategories ? (
                <div style={{ textAlign: "center", padding: "50px" }}>
                  <Spin size="large" />
                  <div style={{ marginTop: "16px" }}>
                    Loading Top Work Categories...
                  </div>
                </div>
              ) : errors.topWorkCategories ? (
                <Alert
                  message="Error Loading Data"
                  description={errors.topWorkCategories}
                  type="error"
                  showIcon
                  style={{ margin: "20px 0" }}
                />
              ) : null}
              <TopWorkCategoriesChart />
            </Card>
          </Col>
        </Row>

        <Row gutter={16} style={{ marginBottom: "20px" }}>
          {/* Top Contractors */}
          <Col xs={24} lg={12}>
            <Card
              title={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span>
                    Top {isClientFlow ? "Clients" : "Contractors"} by Work
                    Orders
                  </span>
                  <a
                    href="#"
                    style={{
                      color: "#cec4c4ff",
                      cursor: "not-allowed",
                      fontSize: "12px",
                      textDecoration: "none",
                    }}
                    onClick={(e) => e.preventDefault()}
                  >
                    View More
                  </a>
                </div>
              }
              style={{ height: "400px" }}
            >
              {loading.topContractors ? (
                <div style={{ textAlign: "center", padding: "50px" }}>
                  <Spin size="large" />
                  <div style={{ marginTop: "16px" }}>
                    Loading Top Contractors...
                  </div>
                </div>
              ) : errors.topContractors ? (
                <Alert
                  message="Error Loading Data"
                  description={errors.topContractors}
                  type="error"
                  showIcon
                  style={{ margin: "20px 0" }}
                />
              ) : null}
              <TopContractorsTable />
            </Card>
          </Col>
          {/* Budget Variance */}
          <Col xs={24} lg={12}>
            <Card
              title={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span>
                    Budget Variance by {isClientFlow ? "Client" : "Contractor"}
                  </span>
                  <a
                    href="#"
                    style={{
                      color: "#cec4c4ff",
                      cursor: "not-allowed",
                      fontSize: "12px",
                      textDecoration: "none",
                    }}
                    onClick={(e) => e.preventDefault()}
                  >
                    View More
                  </a>
                </div>
              }
              style={{ height: "400px" }}
            >
              {loading.budgetVariance ? (
                <div style={{ textAlign: "center", padding: "50px" }}>
                  <Spin size="large" />
                  <div style={{ marginTop: "16px" }}>
                    Loading Budget Variance...
                  </div>
                </div>
              ) : errors.budgetVariance ? (
                <Alert
                  message="Error Loading Data"
                  description={errors.budgetVariance}
                  type="error"
                  showIcon
                  style={{ margin: "20px 0" }}
                />
              ) : null}
              <BudgetVarianceTable />
            </Card>
          </Col>
        </Row>
        <Row gutter={16} style={{ marginBottom: "20px" }}>
          {/* Work Execution Status */}
          <Col xs={24} lg={12}>
            <Card
              title={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span>Work Execution Monitoring</span>
                  <a
                    href="#"
                    style={{
                      color: "#cec4c4ff",
                      cursor: "not-allowed",
                      fontSize: "12px",
                      textDecoration: "none",
                    }}
                    onClick={(e) => e.preventDefault()}
                  >
                    View More
                  </a>
                </div>
              }
              style={{ height: "450px" }}
            >
              {loading.workExecutionMonitoring ? (
                <div style={{ textAlign: "center", padding: "50px" }}>
                  <Spin size="large" />
                  <div style={{ marginTop: "16px" }}>
                    Loading Work Execution Monitoring...
                  </div>
                </div>
              ) : errors.workExecutionMonitoring ? (
                <Alert
                  message="Error Loading Data"
                  description={errors.workExecutionMonitoring}
                  type="error"
                  showIcon
                  style={{ margin: "20px 0" }}
                />
              ) : null}
              <WorkExecutionMonitoringChart />
            </Card>
          </Col>
          {/* Pending Execution Approvals */}
          <Col xs={24} lg={12}>
            <Card
              title={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span>Pending Execution Approvals</span>
                  <a
                    href="#"
                    style={{
                      color: "#cec4c4ff",
                      cursor: "not-allowed",
                      fontSize: "12px",
                      textDecoration: "none",
                    }}
                    onClick={(e) => e.preventDefault()}
                  >
                    View More
                  </a>
                </div>
              }
              style={{ height: "450px" }}
            >
              {loading.pendingExecutionApprovals ? (
                <div style={{ textAlign: "center", padding: "50px" }}>
                  <Spin size="large" />
                  <div style={{ marginTop: "16px" }}>
                    Loading Pending Approvals...
                  </div>
                </div>
              ) : errors.pendingExecutionApprovals ? (
                <Alert
                  message="Error Loading Data"
                  description={errors.pendingExecutionApprovals}
                  type="error"
                  showIcon
                  style={{ margin: "20px 0" }}
                />
              ) : null}
              <PendingExecutionApprovalsTable />
            </Card>
          </Col>
        </Row>
        {/* Contractor Summary - Full Width Carousel */}
        <Row gutter={16} style={{ marginBottom: "20px" }}>
          <Col xs={24}>
            <Card
              title={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span>{isClientFlow ? "Client" : "Contractor"} Summary</span>
                  <a
                    href="#"
                    style={{
                      color: "#cec4c4ff",
                      cursor: "not-allowed",
                      fontSize: "12px",
                      textDecoration: "none",
                    }}
                    onClick={(e) => e.preventDefault()}
                  >
                    View More
                  </a>
                </div>
              }
              style={{ minHeight: "380px" }}
            >
              {loading.contractorSummary ? (
                <div style={{ textAlign: "center", padding: "50px" }}>
                  <Spin size="large" />
                  <div style={{ marginTop: "16px" }}>
                    Loading {isClientFlow ? "Client" : "Contractor"} Summary...
                  </div>
                </div>
              ) : errors.contractorSummary ? (
                <Alert
                  message="Error Loading Data"
                  description={errors.contractorSummary}
                  type="error"
                  showIcon
                  style={{ margin: "20px 0" }}
                />
              ) : null}
              <ContractorSummaryCarousel />
            </Card>
          </Col>
        </Row>
      </Content>
    </React.Fragment>
  );
};

export default ProcurexDashboard;
